const ID = {
  '1': 'Januari',
  '2': 'Februari',
  '3': 'Maret',
  '4': 'April',
  '5': 'Mei',
  '6': 'Juni',
  '7': 'Juli',
  '8': 'Agustus',
  '9': 'September',
  '10': 'Oktober',
  '11': 'November',
  '12': 'Desember',
  'recharge.result.pending': 'Operasi selesai',
  'recharge.result.tips': 'Jika koin tidak tiba tepat waktu, jangan khawatir, mungkin ada penundaan jaringan. Jika Anda memiliki pertanyaan, silakan hubungi layanan pelanggan resmi Soyou.',
  'recharge.result.tips.click': 'Klik untuk kembali ke APP',
  'coin.recharge.modal.title': 'Metode Pembayaran',
  'coin.recharge.change.country': 'Pilih negara',
  'coin.recharge.current.country': 'Saat ini menggunakan saluran pembayaran',
  'ajax.timeout': 'Maaf, ada yang tidak beres. Silakan coba lagi nanti',
  'ajax.system': 'Maaf, ada yang tidak beres. Silakan coba lagi nanti',
  'ajax.network': 'Tidak ada koneksi jaringan. Silakan coba lagi nanti.',
  'blank': '<p>Tidak ada konten terkait</p> <p>Silakan periksa saluran lain</p>',
  'pull.refresh.deactivate': 'Tarik untuk menyegarkan',
  'pull.refresh.activate': 'Rilis untuk menyegarkan',
  'pull.refresh.release': 'Memuat lebih banyak',
  'push.refresh.activate': 'Memuat lebih banyak',
  'push.refresh.noMore': 'Tidak ada info lebih lanjut',
  'click.refresh': 'Klik untuk menyegarkan',
  'share.whatsapp.tip': 'WhatsApp mungkin tidak diinstal pada telepon Anda, instal dan coba lagi.',
  'share.ok': 'OK',
  'share.install': 'Instal Soundi Radio APP Sekarang',
  'share.download': 'Unduh',
  'share.play': 'Putar di Soundi Radio',
  'share.live': 'Live',
  'expection.oops': 'UPS...',
  'expection.homeBtn': 'Halaman Utama',
  'ERR500.tips': 'Ada yang tidak beres. Pengembang telah diberitahu tentang hal ini dan akan memperbaiki masalah ini. Silakan dicoba lagi nanti. Terima kasih.',
  'err404.tips': 'Berita yang Anda cari tidak ada. Silakan periksa topik lainnya. Kami menunggumu di sana!',
  'commonErr': '<p>Sistem sibuk,</p> <p>silakan coba lagi nanti</p>',
  'loading': 'Memuat...',
  'retry': 'Ulang',
  'viewMore': 'Lihat lebih banyak',
  'more': 'lebih banyak',
  'month.select': 'Pilih Bulan',
  'hot': 'Hot',
  'all': 'Semua',
  'month.select.day': 'Pilih Tanggal',
  'coin.merchant.title': 'CoinSeller',
  'coin.merchant.set.password': 'Tetapkan kata sandi trading Anda',
  'coin.merchant.confirm.again': 'Konfirmasi kembali password transaksi',
  'coin.merchant.enter.password': 'Masukkan kata sandi transaksi Anda',
  'coin.merchant.enter.original.password': 'Masukkan kata sandi asli',
  'coin.merchant.enter.new.password': 'Masukkan kata sandi baru',
  'coin.merchant.confirm.new.again': 'Konfirmasikan kata sandi baru lagi',
  'coin.merchant.change.password': 'Perubahan\nkata sandi',
  'coin.merchant.history.title': 'Transaksi\nSejarah',
  'coin.merchant.history': 'Sejarah',
  'coin.merchant.user': 'Pengguna',
  'coin.merchant.chat': 'Chat',
  'coin.merchant.coins.num': 'Inventaris Koin:',
  'coin.merchant.transfer.coins': 'Transfer Koin',
  'coin.merchant.enter.user.id': 'Masukkan user id',
  'coin.merchant.search': 'Inquiry',
  'coin.merchant.not.found': 'Pengguna tidak ditemukan',
  'coin.merchant.enter.amount': 'Masukkan jumlah',
  'coin.merchant.tips': 'Anda akan mentransfer jumlah tambahan kepada pengguna, harap konfirmasi nama dan jumlah koin lagi. Operasi ini tidak dapat diubah, dan pejabat tersebut tidak bertanggung jawab atas kesalahan operasi apa pun.',
  'coin.merchant.enter.transaction.password': 'Masukkan password transaksi',
  'common.cap.Confirm': 'Konfirmasi',
  'coin.merchant.enter': 'Masuk',
  'coin.merchant.to': 'Kepada:',
  'coin.merchant.amount': 'Jumlah:',
  'coin.merchant.id': 'ID',
  'coin.merchant.password.tips': 'Kata sandi harus minimal 8 karakter, dan harus terdiri dari huruf kapital dan huruf kecil dan angka.',
  'coin.merchant.password.error': 'Kata Sandi Salah.Silakan coba lagi.',
  'coin.merchant.success': 'Pengiriman uang berhasil',
  'coin.merchant.list.title': 'Pilih jumlah',
  'coin.merchant.list.desc': 'Transfer koin ke pengguna ini setara dengan isi ulang, yang juga akan meningkatkan pengalaman vip.',
  'coin.merchant.transfer': 'Transfer',
  'coin.merchant.recharge.title': 'Penjual koin\nIsi ulang',
  'coin.merchant.min.input': 'Jumlah minimum 1000',
  'coin.merchant.der.channel': 'Cara Pembayaran:',
  'coin.merchant.der.channel.tips': 'Jika Anda tidak dapat menyelesaikan pembayaran melalui metode berikut, silakan hubungi WhatsApp tim resmi untuk menanyakan tentang pembelian:',
  'coin.merchant.der.channel.tips.link': 'Salin',
  'coin.merchant.der.current.country': 'Saat ini menggunakan saluran pembayaran',
  'coin.merchant.der.change.country': 'Pilih negara',
  'coin.merchant.der.modal.title': 'Metode Pembayaran',
  'common.cap.Recharge': 'Isi ulang',
  'coin.merchant.der.id': 'TalkTalk ID',
  'coin.merchant.der.name': 'Nama panggilan TalkTalk Anda:',
  'coin.merchant.der.error': '*Tidak Ada Hasil yang Ditemukan',
  'coin.merchant.der.amount': 'Jumlah Isi Ulang:',
  'coin.merchant.der.redeem': 'Tebus',
  'coin.merchant.der.fail': 'Gagal Mengisi Ulang',
  'coin.merchant.der.fail.tips': 'Gagal mengisi ulang akun Anda, silakan hubungi kami di: TT_support@molelive.com jika Anda memiliki pertanyaan!',
  'coin.merchant.der.complete': 'Isi Ulang Selesai',
  'coin.merchant.der.complete.tips': '{number} koin telah berhasil diisi ulang ke {name}! Silakan masuk untuk menikmati lebih banyak kesenangan!',
  'coin.merchant.der.another': 'Isi ulang akun lain',
  'coin.merchant.der.more': 'Isi Ulang Lebih Banyak',
  'coin.merchant.der.problem': 'Mengalami masalah?',
  'coin.merchant.der.bind.phone': 'Mengikat nomor ponsel',
  'coin.merchant.der.sms.code': 'Masukkan kode verifikasi',
  'coin.merchant.der.sms.tips': 'Aktivitas abnormal telah terdeteksi. Untuk memastikan keamanan akun Anda, selesaikan proses verifikasi di bawah ini.',
  'coin.merchant.der.bind.phone.placeholder': 'Nomor Telepon',
  'coin.merchant.der.resend': 'Kirim ulang',
  'common.cap.Continue': 'Teruskan',
  'coin.merchant.der.code.tips': 'Jika Anda tidak dapat menerima kode verifikasi, silakan hubungi WhatsApp tim resmi:',
  'total.rank.gift': 'MINGGUAN<br />BINTANG',
  'total.rank.hour': 'Setiap jam',
  'total.rank.day': 'Hari',
  'total.rank.week': 'Unduhan',
  'total.rank.month': 'Bulanan',
  'total.rank.last.hour': 'TOP3 Jam Terakhir',
  'total.rank.last.day': 'Hari Terakhir TOP3',
  'total.rank.last.week': 'Minggu Lalu TOP3',
  'total.rank.last.month': 'TOP3 Bulan Lalu',
  'total.rank.this.hour': 'Jam ini',
  'total.rank.this.day': 'Hari ini',
  'total.rank.this.week': 'Minggu ini',
  'total.rank.this.month': 'Bulan ini',
  'total.rank.gap': 'Gap{X}',
  'total.rank.hide': 'Sembunyikan di Peringkat',
  'total.rank.hide.name': 'Mr.Misteri',
  'total.rank.hide.info': 'Informasi Tersembunyi',
  'total.rank.help.title': 'Aturan Peringkat',
  'total.rank.help': '<h1>Jenis Peringkat</h1>\n<p>Peringkat &lt;ruangan&gt;: Selama periode waktu tersebut, semua ruangan akan diberi peringkat sesuai dengan jumlah hadiah koin yang dikirim ke dalam ruangan.</p>\n<p>Peringkat &lt;GIFTER&gt;: Selama periode waktu tersebut, semua pengguna akan diberi peringkat sesuai dengan jumlah hadiah koin yang dikirim oleh pengguna.</p>\n<p>Peringkat &lt;CHARMER&gt;: Selama periode waktu tersebut, semua pengguna akan diberi peringkat sesuai dengan jumlah hadiah koin yang Anda terima.</p>\n<h1>Peringkat Siklus Waktu</h1>\n<p>Siklus peringkat biasanya jam, hari, minggu, dan bulan.</p>\n<p>Peringkat menunjukkan 3 teratas dari siklus sebelumnya, serta 50 teratas dari siklus saat ini, diperbarui secara real time.\n(Dengan penundaan kurang dari 1 menit)</p>\n<p>Waktu Refresh (UTC+7): Refresh Peringkat Harian pada jam 5 pagi; Penyegaran Peringkat Mingguan pukul 5 pagi setiap hari Senin; Penyegaran Peringkat Bulanan pukul 5 pagi pada tanggal 1 setiap bulan.</p> \n<h1>Perlindungan Privasi</h1> \n<p>Beberapa Peringkat tidak akan menampilkan angka tertentu; </p> \n<p>Namun, perbedaan antara peringkat sebelumnya ditampilkan; </p> \n<p>3 teratas tidak akan menunjukkan perbedaan antara satu sama lain.</p>',
  'total.rank.help.eu': '<h1>Jenis Peringkat</h1>\n<p>Peringkat &lt;GIFTER&gt;: Selama periode waktu tersebut, semua pengguna akan diberi peringkat sesuai dengan jumlah hadiah koin yang dikirim oleh pengguna.</p>\n<p>Peringkat &lt;CHARMER&gt;: Selama periode waktu tersebut, semua pengguna akan diberi peringkat sesuai dengan jumlah hadiah koin yang Anda terima.</p>\n<h1>Peringkat Siklus Waktu</h1>\n<p>Peringkat menunjukkan 3 teratas dari siklus sebelumnya, serta 50 teratas dari siklus saat ini, diperbarui secara real time.\n(Dengan penundaan kurang dari 1 menit)</p>\n<p>Waktu Refresh (UTC+7): Refresh Peringkat Harian pada jam 5 pagi; Penyegaran Peringkat Mingguan pukul 5 pagi setiap hari Senin; Penyegaran Peringkat Bulanan pukul 5 pagi pada tanggal 1 setiap bulan.</p>\n<h1>Perlindungan Privasi</h1>\n<p>Beberapa Peringkat tidak akan menampilkan angka tertentu; </p>\n<p>Namun, perbedaan antara peringkat sebelumnya ditampilkan; </p>\n<p>3 teratas tidak akan menunjukkan perbedaan antara satu sama lain.</p>',
  'common.cap.Ranking': 'PERINGKAT',
  'total.rank.room': 'ruangan',
  'total.rank.sent': 'GIFTER',
  'common.up.RECEIVED': 'PAWANG',
  'fission.relation.by.amount': 'Berdasarkan Jumlah',
  'fission.relation.by.time': 'Berdasarkan Waktu',
  'common.cap.Countdown': 'Countdown',
  'common.up.RULES': 'ATURAN',
  'common.up.DAYS': 'HARI',
  'common.up.HOURS': 'JAM',
  'common.up.MINS': 'MENIT',
  'common.cap.Successfully.Collected': 'Berhasil Dikumpulkan',
  'common.cap.Countdown.to.Start': 'Hitungan Mundur Untuk Memulai',
  'common.cap.Day': 'Hari',
  'common.cap.Hour': 'Jam',
  'common.cap.Min': 'Min',
  'common.cap.Sec': 'Sec',
  'common.cap.Rules': 'Aturan',
  'common.cap.event.over': 'Acara selesai',
  'recharge.event.tab.1': 'Kemajuan Isi Ulang',
  'recharge.event.amount.reached': 'Jumlah koin yang dicapai',
  'recharge.event.ranking.list': 'Daftar Peringkat',
  'recharge.event.group': 'Kelompok',
  'recharge.event.next.1': 'Hanya perlu',
  'recharge.event.next.2': 'koin untuk mencapai level berikutnya',
  'recharge.event.rewards.for': 'Hadiah Untuk',
  'recharge.event.trouble': 'Apakah Anda mengalami masalah dengan pengisian ulang?',
  'recharge.event.done': 'Selamat! Anda telah mencapai level tertinggi! Nikmati hadiah Anda sekarang!',
  'fission.trouble': 'Apakah Anda mengalami masalah dengan pengisian ulang?',
  'common.cap.No': 'Tidak',
  'common.cap.Unfortunately.Yes': 'Sayangnya ya',
  'common.cap.Waiting': 'Menunggu',
  'common.cap.update': 'Harap perbarui versi untuk menggunakan fitur baru',
  'common.cap.Customer.Server': 'Layanan Pelanggan',
  'common.cap.Ranking.click': 'Klik',
  'common.cap.Ranking.click.text': 'untuk memeriksa hadiah yang berbeda',
  'common.cap.Collect': 'Mengumpulkan',
  'common.cap.Collected': 'Dikumpulkan',
  'common.cap.Limited.Gifts': 'Hadiah Terbatas',
  'family.football.target': 'Target Hadiah Koin',
  'dream.city.rule.reward': 'Aturan&\nHadiah',
  'dream.city.city.map': 'Peta Kota',
  'dream.city.rules': 'Aturan Acara',
  'dream.city.supply.reward': 'Hadiah Stasiun Pasokan',
  'dream.city.wealth': 'Kekayaan',
  'dream.city.charm': 'Jimat',
  'dream.city.wealth.rank': 'Kekayaan',
  'dream.city.charm.rank': 'Jimat',
  'dream.city.current.coins': 'Koin Saat Ini',
  'dream.city.current.diamonds': 'Berlian Saat Ini',
  'dream.city.go': 'GO',
  'dream.city.will.get': 'Anda akan mendapatkan',
  'dream.city.received': 'Selamat! Anda telah menerima',
  'dream.city.top5': '5 pengguna teratas yang mencapai stasiun pasokan di sonnest akan mendapatkan hadiah pasokan.',
  'dream.city.waiting': 'Menunggu',
  'about.title': 'Mengenai',
  'Terms of Service': 'Persyaratan Layanan',
  'Privacy Policy': 'Kebijakan Privasi',
  'Return Policy': 'Kebijakan Pengembalian',
  'Intellectual Property Rights': 'Hak Kekayaan Intelektual',
  'Contact Us': 'Hubungi kami',
  'About Us': 'Tentang kita',
  'Supported Payment Methods': 'Metode Pembayaran yang Didukung',
  'subTitle': 'Jangan memercayai saluran isi ulang lain selain merchant terverifikasi.',
  'chat': 'Chat',
  'id': 'Soyou ID',
  'contact': 'Kontak',
  'whatsapp': 'WhatsApp',
  'right': 'Tim Soyou berhak atas interpretasi akhir.',
  'check': 'Kata sandi harus terdiri dari 8 digit dan huruf besar dan kecil',
  'same': 'Silakan masukkan kata sandi yang sama',
  'copied': 'Tersalin',
  'details': 'Detail Berlian',
  'miss': 'Berlian yang Terlewatkan',
  'profit': 'Statistik Pendapatan',
  'missToday': 'Terlewatkan-Hari Ini',
  'cumulativeMiss': 'Terlewatkan-Total',
  'distributionOfDiamondIncome': 'Distribusi pendapatan berlian',
  'getDiamondsMonth': 'Berlian bulan ini:',
  'getDiamondsDay': 'Berlian hari ini:',
  'cancel': 'Membatalkan',
  'confirm': 'Mengkonfirmasi',
  'daily': 'Harian',
  'month': 'Bulan',
  'tips': 'Tidak ada lagi data',
  'voiceChat': 'Penilaian pengguna <br /> untuk Voice Chat dengan anchor',
  'voiceChat1': 'Penilaian pengguna <br /> untuk Voice Chat dengan saya',
  'quickCall': 'Penilaian pengguna <br /> untuk Panggilan Cepat dengan anchor',
  'quickCall1': 'Penilaian pengguna <br /> untuk Quick Call dengan saya',
  'chatting': 'Performa message chat',
  'chatting1': 'Performa obrolan saya',
  'chatSpeed': 'Kecepatan balasan',
  'chatSpeed1': 'Kecepatan saya membalas pesan',
  'like': 'suka',
  'boring': 'Membosankan',
  'Hate': 'Benci',
  'chatConversation': '💬 Putaran Chat',
  'reached': '🙋‍♀️Jumlah pengguna',
  'count': '🙋‍♀️ Messages',
  'speed': 'Kecepatan balasan',
  'quality': 'Kualitas obrolan',
  'call': 'Panggilan & Peringkat',
  'currentCycle': 'Siklus Saat Ini',
  'speedTitle': 'Balas Aturan Pendapatan Pesan',
  'roundTitle': 'Aturan Pendapatan Putaran Obrolan',
  'modalTips': 'Semakin cepat Anda membalas pesan akan meningkatkan pengalaman pengguna, dan semakin banyak berlian yang Anda peroleh.',
  'modalTipsTwo': 'Kualitas konten balasan Anda yang lebih tinggi dan lebih banyak putaran obrolan akan meningkatkan pengalaman pengguna, dan semakin banyak berlian yang Anda peroleh:',
  'modalSpeed': 'Kecepatan respons',
  'modalIncome': 'Tingkat Pendapatan',
  'modalRound': 'Putaran obrolan',
  'modalReward': 'Hadiah ekstra',
  'modalBtn': 'Lanjutkan Ke Chat',
  'cycleDiamonds': 'Berlian siklus ini',
  'terms.help': 'Masalah Aplikasi',
  'terms.bug': 'Bug',
  'terms.suggestions': 'Saran',
  'contacts.whatsapp': 'Whatsapp',
  'contacts.email': 'Email',
  'contacts.phone': 'Telepon',
  'submit.success': 'Terima kasih atas tanggapan Anda',
  'terms.title': 'Kategori',
  'details.placeholder': 'Tolong jelaskan detail masalah Anda',
  'contacts.title': 'Cara menghubungi Anda',
  'contact.placeholder': 'Tinggalkan informasi kontak Anda di sini[Rahasia]',
  'submit.btn': 'Kirim ulang',
  'country.select.hot': 'Hot',
  'country.select.all': 'Semua',
  'feedback.details': 'Rincian',
  'feedback.screenshot': 'Tangkapan layar (Opsional)',
  'feedback.title': 'Feedback',
  'flowWater': 'Detail Koin',
  'coinBack': 'Koin Dikembalikan',
  'home.recharge': 'Isi ulang',
  'home.slogan': 'Temui belahan jiwamu Di sini<br />Selalu bersamamu',
  'home.download': 'Unduhan',
  'income.rules.rules.1': '1. Aturan Gaji: tanggal 16 setiap bulannya dan tanggal satu bulan berikutnya pukul 00:00 akan dipotong dari saldo rekening berlian',
  'income.rules.rules.2': '2. Rasio Gaji: 1USD = 0diamonds',
  'income.rules.rules.3': '3. Waktu Penyelesaian: (1)tanggal 16 setiap bulan 00:00(2) bulan pertama bulan berikutnya 00:00',
  'income.rules.rules.4': '4. Periode Penyelesaian: 7 ~ 14 hari kerja (hari libur ditunda)',
  'income.rules.chat': 'Hubungi Layanan Pelanggan',
  'income.rules.important': 'Penekanan:',
  'income.rules.title': 'Aturan Gaji',
  'income.rules.rules.extra': 'Kami akan memberi tahu Anda melalui \"Tim Soyou\" ketika gaji diselesaikan. Detail pengurangan berlian dapat diperiksa di \"Pendapatan\", harap perhatikan pemberitahuan Tim Soyou. Penyelesaian normal akan selesai dalam 7-14 hari kerja, jika ada hari libur, periode rilis bank akan tertunda, harap bersabar dan tunggu pembayaran. Jika Anda memiliki pertanyaan, silakan hubungi Layanan Pelanggan Soyou, terima kasih atas dukungan Anda!',
  'income.rules.usd': 'USD',
  'income.rules.diamonds': 'Berlian',
  'my.earning.title': 'Penghasilan Saya',
  'my.earning.tips': 'Saldo berlian',
  'my.earning.daimonds': 'Berlian',
  'my.earning.withdrawal.rules': 'Aturan Penarikan',
  'my.earning.salary.rules': 'Aturan Gaji',
  'new.task.go': 'Go',
  'new.task.done': 'Selesai',
  'task.center.title': 'Pusat Tugas',
  'recharge.result.success': 'Pembayaran Berhasil',
  'recharge.result.error': 'Pembayaran Gagal',
  'common.up.OK': 'OK',
  'report.option.Porn': 'Pornografi',
  'report.option.Spam': 'Spam',
  'report.option.Fraud': 'Penipuan',
  'report.option.Violence': 'Kekerasan',
  'report.option.Illegal': 'Ilegal',
  'report.option.Other': 'Lainnya',
  'report.option.room': 'Saya tidak suka ini',
  'report.option.user': 'Saya tidak suka penggunanya',
  'report.reason': 'Kategori',
  'report.details': 'Rincian',
  'report.details.placeholder': 'Menjelaskan detail laporan Anda',
  'report.screenshot': 'Tangkapan layar (Opsional)',
  'report.submit': 'Kirim',
  'report.submit.success': 'Berhasil dilaporkan',
  'report.room': 'Lapor',
  'report.user': 'Lapor pengguna',
  'retirar.rules.title': 'Aturan Penarikan',
  'retirar.rules.rules.1': '1.Sebelum menggunakan layanan penarikan, Anda perlu mengirimkan informasi identitas asli untuk memastikan keamanan akun Anda',
  'retirar.rules.rules.2': '2. Harap berikan informasi identitas asli yang akan digunakan sebagai dasar untuk identifikasi dan penentuan hak untuk menggunakan akun Soyou Anda',
  'retirar.rules.rules.3': '3. Informasi identitas yang Anda kirimkan akan dijaga kerahasiaannya dan tidak akan digunakan untuk tujuan lain',
  'retirar.rules.chat': 'Hubungi Layanan Pelanggan',
  'retirar.rules.important': 'Penekanan:',
  'retirar.rules.rules.extra': 'Silakan hubungi layanan pelanggan dengan kebutuhan untuk menggunakan layanan penarikan dan berikan informasi berikut:',
  'retirar.rules.rules.extra.1': '1) Nama asli',
  'retirar.rules.rules.extra.2': '2) Nomor Whatsapp',
  'retirar.rules.rules.extra.3': '3) Dokumen identitas (kartu identitas, paspor, dll.)',
  'retirar.rules.rules.extra.4': '4) Metode pembayaran Anda (Transfer Bank, Payoneer, Fawry, dll.)',
  'task.center.retirar': 'Klaim Sekarang',
  'task.center.complete': 'Selesai',
  'lucky.darw.end': 'Acara tidak berlangsung',
  'total.rank.daily': 'Harian',
  'task.center.common.level': 'Level',
  'common.cap.Event.To.Start': 'Acara akan segera dimulai',
  'task.center.limit.task': 'Limited Task',
  'task.center.normal.task': 'Normal Task',
  'task.center.limit.today': 'Today',
  'task.center.limit.Total': 'Total',
  'task.center.limit.Diamonds.Received': 'Diamonds Received',
  'task.center.limit.Reward.Received': 'Reward Received',
  'task.center.limit.receive': 'Receive',
  'task.center.limit.extra': 'Extra',
  'task.center.limit.to.start': 'Event has not started yet',
  'gift.wall.title': 'Hadiah',
  'gift.wall.help.text1': 'Hadiah yang melebihi {num} koin sekaligus akan muncul di dinding hadiah',
  'gift.wall.help.text2': 'Hadiah dengan jumlah koin yang lebih besar akan ditampilkan di peringkat pertama',
  'gift.wall.help.text3': 'Catatan di dinding hadiah akan disimpan selama 24 jam',
  'level.user': 'Level Pengguna',
  'level.halo': 'Level Halo',
  'level.halo.question1.title': 'Manfaat dari Level Tinggi',
  'level.halo.question1.answer1': 'Semakin Tinggi Level, Semakin Terang Halo',
  'level.halo.question2.title': 'Tampilan Level Ikon',
  'level.halo.question2.answer1': 'Semakin tinggi level, semakin unik ikonnya',
  'level.halo.question3.title': 'Hadiah Level Up',
  'level.halo.question3.answer1': 'Tingkatkan Level Untuk Mendapatkan Hadiah Menakjubkan',
  'level.halo.question4.title': 'Cara Meningkatkan Level',
  'level.halo.question4.answer1': 'Terima hadiah senilai 1 koin, Dapatkan 1 pengalaman. Semakin tinggi pengalaman, semakin cepat naik level.',
  'level.user.question1.title': 'Manfaat dari Level Tinggi',
  'level.user.question1.answer1': 'Anda akan mendapatkan item dan hadiah khusus.',
  'level.user.question2.title': 'Cara Meningkatkan Level',
  'level.user.question2.answer1': 'Berkomunikasi di ruangan, bermain game, dan mengirim hadiah',
  'level.user.question2.answer2': 'Selesaikan tugas harian, dapatkan pengalaman untuk naik level',
  'level.user.question2.answer7': 'Bergabung dengan pesta di ruangan',
  'level.user.question2.answer8': 'Kirim hadiah dengan koin',
  'level.user.question2.answer9': 'Selesaikan tugas dan klaim EXP',
  'level.user.question3.title': 'Tampilan Level Ikon',
  'level.user.question3.answer1': 'Semakin tinggi level, semakin unik ikonnya',
  'level.user.question4.title': 'Hadiah Level Up',
  'level.user.question4.answer1': 'Tingkatkan Level Untuk Mendapatkan Hadiah Menakjubkan',
  'level.user.level': 'Level',
  'level.user.icon': 'Ikon',
  'level.user.tips': 'Saat Anda terus mendapatkan poin EXP, level Anda akan bertambah secara bertahap.',
  'level.user.way.up': 'Cara meningkatkan poin EXP:',
  'about.badges.title': 'Tentang Lencana',
  'about.badges.0': 'Pakai lencana',
  'about.badges.1': 'Semua lencana dapat dipakai, dan hingga lima lencana dapat dipakai secara bersamaan.',
  'about.badges.2': 'Lencana Kehormatan',
  'about.badges.3': 'Lencana yang terbuka berdasarkan nilai akumulasi bulanan dihitung pada tanggal 1 setiap bulan, baik lencana tersebut dimiliki atau tidak. Masa berlaku lencana tersebut adalah selama satu bulan.',
  'vip.privileges.title.privacy': 'Keamaan Pribadi',
  'vip.privileges.label.privacy': 'Room mu tidak bisa ditemukan',
  'vip.privileges.title.invisible': 'Mode tidak terlihat',
  'vip.privileges.label.invisible': 'Mode tidak terlihat dan sembunyikan kamu dari rekomendasi',
  'vip.privileges.title.blockMessages': 'Mode diam',
  'vip.privileges.label.blockMessages': 'Block orang tidak dikenal',
  'vip.privileges.title': 'Privilige Soyou VIP',
  'vip.privileges.activate': 'Aktifkan VIP{N}',
  'vip.privileges.stealth.text': 'Sembunyikan riwayat akses saya',
  'vip.privileges.stealth.open': 'Buka',
  'vip.privileges.stealth.close': 'Tutup',
  'vip.privileges.title.icon': 'Label VIP',
  'vip.privileges.label.icon': 'Label VIP yang menonjol, identitas eksklusif pengguna VIP, menunjukkan kehormatan Anda.',
  'vip.privileges.title.visitor': 'Jejak Kunjungan',
  'vip.privileges.label.visitor': 'Lihat semua jejak pengunjung sehingga Anda tidak melewatkan orang yang menarik dan penggemar.',
  'vip.privileges.title.list': 'Tampilan Prioritas',
  'vip.privileges.label.list': 'Tampilan prioritas hasil pencarian.',
  'vip.privileges.title.follower': 'Batas Atas Mengikuti yang Lebih Tinggi.',
  'vip.privileges.label.follower': 'Anda dapat mengikuti lebih banyak teman untuk memperluas lingkaran teman. Non-VIP dapat mengikuti 500 orang VIP1-VIP3 dapat mengikuti 1000 orang VIP4-VIP6 dapat mengikuti 2000 orang VIP7 ke atas dapat mengikuti 3000 orang',
  'vip.privileges.title.sign': 'Hadiah Check-in VIP',
  'vip.privileges.label.sign': 'VIP dapat mengklaim hadiah check-in ganda',
  'vip.privileges.title.stealth': 'Kunjungan Tidak Terlihat',
  'vip.privileges.label.stealth': 'Ketika Anda mengunjungi pengguna lain, tidak ada riwayat yang akan dicatat',
  'vip.privileges.title.name': 'Sorotan Nama Pengguna',
  'vip.privileges.label.name': 'Pengguna akan mendapatkan efek khusus untuk menghias nama pengguna',
  'vip.privileges.title.avatar': 'Bingkai VIP',
  'vip.privileges.label.avatar': 'Bingkai eksklusif untuk menunjukkan identitas Anda.',
  'vip.privileges.title.bubble': 'Bubble Chat VIP',
  'vip.privileges.label.bubble': 'Bubble chat eksklusif membuat ucapan Anda menonjol.',
  'vip.privileges.title.room': 'Kartu Mini VIP',
  'vip.privileges.label.room': 'Kartu ruangan VIP eksklusif',
  'vip.privileges.title.picture': 'Kartu mini eksklusif untuk menyoroti kehormatan Anda.',
  'vip.privileges.label.picture': 'Opsi untuk mengirim gambar pada bullet chat',
  'vip.privileges.title.message': 'Daftar Pesan Teratas',
  'vip.privileges.label.message': 'Anda dapat menempatkan dialog pengguna lain di bagian atas daftar pesan.',
  'vip.privileges.title.vehicle': 'Kendaraan VIP',
  'vip.privileges.label.vehicle': 'Kendaraan VIP eksklusif',
  'vip.privileges.title.rank': 'Sembunyikan Identitas',
  'vip.privileges.label.rank': 'Anda dapat mengaktifkan tombol [Sembunyikan Identitas] untuk muncul sebagai orang misterius di peringkat.',
  'vip.privileges.title.broadcast': 'Pemberitahuan Aplikasi',
  'vip.privileges.label.broadcast': 'Ketika Anda mencapai VIP8 dan di atasnya, peningkatan akan memicu pemberitahuan aplikasi.',
  'vip.privileges.title.id': 'ID Eksklusif',
  'vip.privileges.label.id': 'Dapatkan ID eksklusif Anda dan biarkan orang lain mengingat Anda dengan sekilas! VIP8: ABABAB (A dan B harus berbeda) VIP9: AAABB (A dan B harus berbeda) VIP10: ABAB (A dan B harus berbeda) VIP11: AABB (A dan B harus berbeda) Semua bentuk tidak boleh dimulai dengan 0. Anda perlu menghubungi layanan pelanggan VIP untuk mendapatkan ID eksklusif.',
  'vip.privileges.title.protection': 'Pencegahan Penghapusan',
  'vip.privileges.label.protection': 'Tidak perlu khawatir tentang dihapus dari mikrofon atau ruangan mana pun.',
  'vip.privileges.title.gif': 'Bingkai Dinamis Kustom',
  'vip.privileges.label.gif': 'Mengkustomisasi bingkai dinamis eksklusif Anda. Ketika Anda mencapai VIP9, silakan hubungi Layanan Pelanggan untuk mendapatkan Bingkai Dinamis Kustom, setiap pengguna hanya memiliki satu kesempatan untuk mengkustomisasi.',
  'vip.privileges.title.gift': 'Hadiah Kustom',
  'vip.privileges.label.gift': 'Kustomisasikan hadiah eksklusif Anda. Ketika Anda mencapai VIP10, silakan hubungi Layanan Pelanggan untuk mendapatkan Hadiah Kustom, setiap pengguna hanya memiliki satu kesempatan untuk mengkustomisasi.',
  'vip.privileges.title.exclusivevehicles': 'Kendaraan Kustom',
  'vip.privileges.label.exclusivevehicles': 'Kustomisasikan kendaraan eksklusif Anda. Ketika Anda mencapai VIP11, silakan hubungi Layanan Pelanggan untuk mendapatkan Kendaraan Kustom, setiap pengguna hanya memiliki satu kesempatan untuk melakukan kustomisasi.',
  'vip.privileges.title.open': 'Halaman Bukaan Kustom',
  'vip.privileges.label.open': 'Pengguna lain dapat melihat Anda secara otomatis setiap kali mereka membuka aplikasi. Kejayaan yang tak tertandingi! Ketika anda mencapai VIP12, mohon kontak Pelayanan Pengguna untuk mendapatkan Halaman Bukaan Kustom selama 24 jam, setiap pengguna hanya mendapatkan satu kali kesempatan untuk melakukan modifikasi.',
  'vip.privileges.update.info': 'Sistem VIP sudah di perbarui, versi anda terlalu lama untuk melihat fitur terbaru. Mohon update versi terbaru dan nikmati fungsi VIP yang baru!',
  'aristocracy.vip.title': 'Aristokrasi',
  'vip.help.1': 'Aturan VIP',
  'vip.help.2': 'Apa itu VIP?',
  'vip.help.3': 'VIP adalah kelas khusus di TalkTalk. Terdapat 16 tingkat identifikasi VIP. Anda akan mendapatkan hak istimewa yang sesuai setelah Anda memiliki VIP.',
  'vip.help.4': 'Bagaimana cara meningkatkan level VIP?',
  'vip.help.5': '1. Melakukan isi ulang senilai $1 akan mendapatkan 1 VIP EXP.\n2. Level VIP Anda akan langsung naik ketika VIP EXP mencapai persyaratan peningkatan pada bulan tersebut.\n3. Mulai dari hari pertama setiap bulan, VIP EXP awal setiap orang akan diatur ulang menjadi 0. Dan level VIP Anda akan ditentukan berdasarkan jumlah akumulasi EXP.',
  'vip.help.6': 'Persyaratan Peningkatan Level VIP',
  'vip.help.7': 'Aturan Peningkatan',
  'vip.help.8': 'Setelah Anda mencapai syarat peningkatan pada bulan ini, level VIP Anda akan segera diperbarui. Level VIP tersebut akan dipertahankan hingga akhir bulan berikutnya. Misalnya, pengguna mencapai VIP5 pada tanggal 10 Maret, dan level VIP5 akan berlanjut hingga 30 April.',
  'vip.help.9': 'Aturan Pemeliharaan/Penurunan Level',
  'vip.help.10': 'Jika total akumulasi nilai EXP Anda mencapai persyaratan untuk level VIP Anda saat ini pada bulan ini, Anda akan mempertahankan level VIP Anda pada bulan berikutnya; jika tidak, level VIP Anda akan diturunkan pada bulan berikutnya. Misalnya, jika Anda adalah VIP5 pada bulan Mei, tetapi Anda hanya mengakumulasi VIP3 pada bulan Mei, maka level VIP Anda akan diturunkan menjadi VIP3 mulai bulan Juni.',
  'vip.help.11': 'Pengembalian Level VIP',
  'vip.help.12': 'Berdasarkan Level VIP pada tanggal 1 setiap bulannya, kami akan mengirimkan jumlah tertentu EXP VIP kepada pengguna sesuai dengan Level VIP mereka pada tanggal 1 setiap bulannya.',
  'vip.help.13': 'Tingkat',
  'vip.help.14': 'Rentang Nilai EXP',
  'vip.help.15': 'Pengembalian Nilai EXP',
  'vip.help.update.info': 'Sistem VIP telah diperbarui, versi anda terlalu lama untuk melihat fitur terbaru. Mohon perbarui ke versi terbaru dan nikmati fitur VIP yang baru!',
  'to.exchange.page.button': 'Pertukaran',
  'ranking.daily': 'Harian',
  'ranking.weekly': 'Mingguan',
  'ranking.contributed': 'Berkontribusi:',
  'ranking.blank.daily': 'Tidak ada yang mengirimkan hadiah hari ini',
  'ranking.blank.weekly': 'Tidak ada yang mengirimkan hadiah minggu ini',
  'lucky.packet.title': 'Amplop keberuntungan',
  'lucky.packet.1': 'Kirim amplop keberuntungan',
  'lucky.packet.2': 'Semua pengguna di ruangan dapat mengirim dan mengklaim amplop keberuntungan',
  'lucky.packet.3': 'Ketika ada banyak amplop keberuntungan di ruangan, mereka akan ditumpuk dan ditampilkan. Semakin awal amplop keberuntungan dikirim, semakin banyak yang ditampilkan di bagian atas.',
  'lucky.packet.4': 'Batasan dan Persyaratan',
  'lucky.packet.5': '1. Hanya mendukung pengiriman koin.',
  'lucky.packet.6': '2. Rentang jumlah koin yang dapat diterbitkan: 1 hingga 9999999\nJumlah orang yang dapat diterbitkan: 3-500\nJumlah default adalah 10 orang.',
  'lucky.packet.7': 'Jumlah per kapita (jumlah koin/jumlah orang) harus lebih besar atau sama dengan 1 koin.',
  'lucky.packet.8': 'Ketika jumlah amplop melebihi 500 koin dan jumlah orang melebihi 3, akan memicu pemberitahuan dunia, dan ikon khusus akan ditampilkan di daftar ruangan.',
  'lucky.packet.9': 'Cara bermain',
  'lucky.packet.10': '1. Amplop keberuntungan dengan kata sandi\n- Anda perlu mengirim kata sandi di ruangan untuk mendapatkannya.',
  'lucky.packet.11': '2. Amplop keberuntungan membutuhkan pengikut\n- Anda perlu mengikuti pengirim amplop keberuntungan untuk mendapatkannya.',
  'lucky.packet.12': 'Masalah Umum',
  'lucky.packet.13': '1. Ketika amplop memicu pemberitahuan dunia atau ketika ikon amplop keberuntungan ditampilkan, orang lain dapat masuk ke ruangan Anda dengan mengkliknya.',
  'lucky.packet.14': '2. Jika Anda mengunci ruangan Anda, pemberitahuan dunia dan ikon tidak akan muncul.',
  'efficient_text_2': 'Waktu yang efektif',
  'efficient_text_5': 'Hari yang efektif',
  'efficient_text_6': '1. Waktu yang valid di dalam ruangan',
  'efficient_text_7': 'Di ruang suara, waktu pada mic - waktu dari mic> = %$ menit adalah waktu yang efektif pada mic. Kami mendorong orang di mic untuk mengambil inisiatif untuk mengobrol dan berinteraksi dengan teman baik untuk waktu yang lama, seperti:',
  'efficient_text_8': 'Waktu di mic',
  'efficient_text_9': 'Waktu luang mikrofon',
  'efficient_text_10': 'Apakah mencapai standar',
  'efficient_text_11': 'Menjelaskan',
  'efficient_text_12': 'Mencapai standar',
  'efficient_text_13': 'Tidak mencapai standar',
  'efficient_text_14': 'Jika waktu di mikrofon berlangsung sampai hari berikutnya, itu dihitung sebagai waktu untuk hari sebelumnya',
  'efficient_text_15': 'Waktu luang mikrofon pada mic <%$ menit',
  'efficient_text_16': 'Waktu libur mic-time pada mic> = %$ menit',
  'efficient_text_17': '12/1 9:00:00 Waktu di mic tidak mencapai standar, itu tidak dapat dihitung sebagai waktu yang efektif',
  'efficient_text_18': '12/1 23:00:00 Waktu di mic berlanjut sampai 12/2 dan berlangsung 90 menit berturut -turut, sehingga dihitung sebagai waktu selama 12/1',
  'efficient_text_19': '2. Hari -hari yang efektif di ruangan itu',
  'efficient_text_20': 'Di ruang suara, semua durasi efektif ditambahkan pada hari> = %$ menit adalah hari yang efektif. Semakin tinggi jumlah hari yang valid, semakin tinggi aktivitasnya, dan laju aktivitas secara langsung mempengaruhi hadiah yang Anda dapatkan.',
  'efficient_text_21': 'Total waktu efektif',
  'efficient_text_22': '12/1 3 kali pada mic di siang hari: 15 menit +35 menit +90 menit. Karena 15 menit tidak memenuhi standar, waktu yang valid = 90 +35 = 125 menit = 02H 05 menit',
  'efficient_text_23': '12/1 Durasi yang valid dari hari itu total = 02H 05 menit> = %$ menit, yang dihitung sebagai hari yang valid',
  'efficient_text_24': '3. Waktu di mic',
  'efficient_text_25': 'Waktu pada mic harus waktu yang efektif, dan waktu yang efektif harus> = %$ menit. Waktu pada mikrofon hanya menunjukkan waktu mengobrol di mikrofon di dalam ruangan. Ini akan dianggap sebagai waktu yang efektif ketika waktu pada mic> = %$ menit, seperti:',
  'efficient_text_26': '4. Detail Data',
  'efficient_text_27': 'Data akan ditampilkan sesuai dengan siklus yang dipilih',
  'efficient_text_28': 'Berlian',
  'efficient_text_29': 'Mengobrol',
  'efficient_text_30': 'Ruang suara',
  'efficient_text_31': 'Detail',
  'efficient_text_32': 'Tanggal',
  'efficient_text_33': 'Waktu di mic',
  'efficient_text_34': 'Waktu yang efektif dari ruang suara',
  'efficient_text_35': 'Hari -hari efektif ruang suara',
  'share_text23': 'unduh',
  'share_text24': 'Bergabunglah dengan kamar',
  'share_text25': 'Saya di ruangan ini, datang dan bergabung dengan kami',
  'share_text26': 'ID kamar',
  'OfficialTask_Card_common_text1': 'Tugas resmi',
  'OfficialTask_Card_common_text2': 'Setelah menyelesaikan tugas hadiah resmi, Anda bisa mendapatkan gundam {%s} berlian!',
  'OfficialTask_dailyCard_text1': 'Hadiah Bor Harian ({%s1}/{%s2})',
  'OfficialTask_dailyCard_text2': 'Acquisition Daily Diamond ({%s1}) mencapai {%s2} 💎, dapatkan {%s3} 💎',
  'OfficialTask_dailyCard_text3': 'Hadiah Bor Harian ({%s3}) mencapai {%s1} 💎, dapatkan {%s2} 💎',
  'OfficialTask_dailyCard_text4': 'Waktu hadiah',
  'OfficialTask_dailyCard_text5': 'PERGI',
  'OfficialTask_PeriodCard_text1': 'Siklus hadiah berlian ({%s1}/{%s2})',
  'OfficialTask_PeriodCard_text2': 'Hadiah berlian siklus ({%s3}) mencapai {%s1} 💎, dapatkan {%s2} 💎',
  'OfficialTask_ActiveCard_text1': 'Hadiah aktif',
  'OfficialTask_ActiveCard_text2': 'Login kumulatif dalam siklus {%s1} tian ({%s2}/{%s3})',
  'OfficialTask_ActiveCard_text3': 'Dan ambil bor setiap hari untuk mencapai {%s1} 💎, dan Anda bisa mendapatkan {%s2} 💎. (Hari ini: {%s3}/{%s4})',
  'OfficialTaskPic_Level_text1': 'Penghasilan Berlian Harian Hadiah Penghasilan Berlian Harian (Pesan IM)',
  'OfficialTaskPic_Level_text2': 'TINGKAT',
  'OfficialTaskPic_Level_text3': 'Target berlian',
  'OfficialTaskPic_Level_text4': 'Hadiah berlian',
  'OfficialTaskPic_Level_text5': 'Hadiah Penghasilan Berlian Harian （Hadiah Ruang Suara: Ruang Suara Normal + Ruang Suara Keluarga)',
  'OfficialTaskPic_Level_text6': 'Hadiah Penghasilan Berlian Periode Kerja (Pesan IM + Semua Hadiah Diterima)',
  'OfficialTaskPic_Level_text7': 'Periode kerja Hadiah Aktif',
  'OfficialTaskPic_Level_text8': 'Masuk untuk {%s1} hari dan dapatkan {%s2} berlian setiap hari',
  'OfficialTaskPic_Level_text9': 'Persyaratan',
  'OfficialTaskPic_Level_text10': 'Hadiah berlian',
  'OfficialTaskPic_Level_text11': 'Melihat:',
  'OfficialTaskPic_Level_text12': '1. Hadiah Ruang Suara: Termasuk ruang suara normal dan ruang suara keluarga;',
  'OfficialTaskPic_Level_text13': '2. Hadiah Aktivitas Periode Kerja: Setelah periode berakhir, jumlah hari aktif akan dihitung, dan hadiah maksimum yang bisa Anda dapatkan adalah 350 berlian;',
  'OfficialTaskPic_Level_text14': '3. Semua Imbalan Berlian akan dikirim langsung ke akun Anda selama periode kerja ini;',
  'OfficialTaskPic_Level_text15': '4. Setiap 70 berlian = 1 USD',
  'OfficialTaskPic_Level_text16': 'Hadiah harian (untuk hadiah dalam obrolan, panggilan audio dan video, kecocokan audio)',
  'OfficialTaskPic_Level_text17': 'Jika Anda menerima berlian untuk hadiah dalam obrolan, panggilan audio-dan video, pencocokan audio dan memenuhi target harian, Anda akan menerima hadiah berlian yang sesuai. Imbalan berlian akan ditambahkan ke acount Anda pada hari berikutnya secara otomatis.',
  'OfficialTaskPic_Level_text18': 'Hadiah harian (untuk hadiah di obrolan dan ruang suara)',
  'OfficialTaskPic_Level_text19': 'Hadiah Periode Kerja (untuk panggilan audio dan video)',
  'OfficialTaskPic_Level_text20': '1. Jika Anda menerima berlian untuk hadiah di obrolan dan ruang suara dan memenuhi target harian, Anda akan menerima hadiah berlian yang sesuai. Imbalan berlian akan ditambahkan ke acount Anda pada hari berikutnya secara otomatis.',
  'OfficialTaskPic_Level_text21': '2. Jika Anda menerima berlian untuk panggilan audio dan video dan memenuhi target pada akhir periode kerja, Anda akan menerima hadiah berlian yang sesuai. Imbalan berlian akan ditambahkan ke acount Anda pada hari berikutnya setelah akhir periode kerja secara otomatis.',
  'OfficialTaskPic_Level_text22': '3. Ada 2 periode kerja yang berlangsung dari tanggal 1 hingga 15 setiap bulan, dan dari 16 hingga 30/31 setiap bulan.',
  'OfficialTaskPic_Level_text23': 'Hadiah Harian 1 (Ruang Pesta Audio & Berlian Hadiah Keluarga)',
  'OfficialTaskPic_Level_text24': 'Hadiah Harian 2 (Panggilan Suara, Suara Match Diamond)',
  'OfficialTaskPic_Level_text25': 'Hadiah Periode Kerja (Obrolan Kencan, Ruang Pesta Audio, Panggilan Suara, Pencocokan Audio)',
  'OfficialTaskPic_Level_text26': '1. Jika Anda menerima berlian untuk hadiah dalam obrolan, ruang audio dan panggilan video, kecocokan audio dan memenuhi target mingguan, Anda akan menerima hadiah berlian yang sesuai. Imbalan Diamond akan ditambahkan ke acount Anda dalam istilah gaji ini secara otomatis.',
  'OfficialTaskPic_Level_text27': '2. Laju Gaji: 100 Berlian = 1 USD ;',
  'OfficialTaskPic_Level_text28': '3. Pengguna berlian yang didapat dari penghargaan harian tidak akan dihitung ke target berlian ini;',
  'OfficialTaskPic_Level_text29': 'Sistem Hadiah Resmi Soyou 02.2024',
  'OfficialTaskPic_Level_text30': 'Tugas Harian 1: Semua Panggilan + Semua Hadiah',
  'OfficialTaskPic_Level_text31': 'Misi Harian 2: Balas Pesan',
  'OfficialTaskPic_Level_text32': 'Target berlian harian',
  'OfficialTaskPic_Level_text33': 'Target berlian harian kami ditunjukkan di atas, dan suatu hari dalam sistem penghargaan kami didasarkan pada waktu setempat Turki.',
  'cms_report_text3': 'Laporkan Alasan:',
  'cms_report_text4': 'Detail Laporan:',
  'cms_report_text5': 'Laporkan tangkapan layar:',
  'cms_report_text6': '*Harap verifikasi informasi di atas. Harap ambil penalti untuk informasi.',
  'cms_report_text7': 'Reporter Showid:',
  'cms_report_text8': 'Reporter showid:',
  'cms_report_text9': 'Metode penalti:',
  'cms_report_text10': 'Hasil penalti:',
  'cms_report_text11': 'Sejarah Hukuman',
  'cms_report_text12': 'Mengurangi peringatan',
  'cms_report_text13': 'Metode pelarangan:',
  'cms_report_text14': 'Alasan Banning:',
  'cms_report_text15': 'Waktu pelarangan:',
  'cms_report_text16': 'Sensitivitas Politik',
  'cms_report_text17': 'Vulgar',
  'cms_report_text18': 'Serangan dan Penyalahgunaan',
  'cms_report_text19': 'Kekerasan berdarah',
  'cms_report_text20': 'Drainase iklan',
  'cms_report_text21': 'Dugaan penipuan',
  'cms_report_text22': 'Informasi ilegal',
  'cms_report_text23': 'Minor',
  'cms_report_text24': 'lainnya',
  'cms_report_text25': 'Konfirmasi',
  'cms_report_text26': 'Operasi Sensitif Akun, Harap Konfirmasi Informasi Setelah Informasi',
  'OfficialTask_dailyCard_text6': 'lengkap',
  'OfficialTask_rewardTime_text1': 'jam',
  'OfficialTask_rewardTime_text2': 'menit',
  'delete_account_web_title': 'Dear Soyou Pengguna. Terima kasih telah menggunakan dan mendukung produk kami. Jika Anda ingin menghapus akun Anda, silakan periksa langkah -langkah berikut untuk diproses:',
  'delete_account_web1': '1. Buka Aplikasi dan Masukkan Halaman Utama, Klik Tab Bawah Kanan untuk Memasuki Saya.',
  'delete_account_web2': '2. Klik Pengaturan Setelah memasuki tab saya.',
  'delete_account_web3': '3. Klik Hapus Akun Setelah Memasuki Pengaturan.',
  'delete_account_web4': '4. Konfirmasikan langkah pertama untuk menghapus akun secara permanen.',
  'delete_account_web5': '5. Konfirmasikan langkah kedua untuk tidak dapat login menggunakan akun yang sama.',
  'delete_account_web6': '6. Konfirmasi langkah terakhir untuk menghapus semua informasi pribadi yang sesuai.',
  'delete_account_web7': '7. Setelah menyelesaikan semua langkah di atas. Akun Anda telah berhasil dihapus, dengan semua informasi pribadi dan data akun Anda. Platform kami tidak akan lagi menyimpan data Anda di database kami.',
  'delete_account_web': 'Hapus Akun',
  'svip_introduce_1': '1.Apa itu SVIP',
  'svip_introduce_text1': 'SVIP adalah sistem level yang dibedakan dalam platform. Total ada 8 level, SVIP1-SVIP8. Semakin tinggi levelnya, semakin tinggi statusnya, dan semakin tinggi hak dan kepentingan yang Anda nikmati.',
  'svip_introduce_2': '2. Bagaimana menjadi SVIP',
  'svip_introduce_text2': 'Anda bisa mendapatkan poin pengalaman SVIP dengan mengisi ulang koin emas, 1 koin emas = 1 poin pengalaman. Ketika poin pengalaman mencapai level SVIP yang berbeda, Anda bisa mendapatkan level SVIP yang sesuai.',
  'svip_introduce_3': '3. Cara menghitung masa berlaku SVIP',
  'svip_introduce_text31': 'SVIP menjadikan setiap bulan alami sebagai sebuah siklus, dan pada tanggal 1 setiap bulan alami, poin pengalaman SVIP diakumulasikan dari 0. Level SVIP yang sesuai akan diperoleh sesuai dengan level yang dicapai oleh nilai pengalaman SVIP.',
  'svip_introduce_text32': 'Sejak Anda memperoleh status SVIP, status dan hak istimewa Anda akan dipertahankan hingga akhir bulan berikutnya. (Misalnya: jika SVIP3 tercapai pada tanggal 18 Mei, maka status SVIP3 akan diperpanjang hingga 30 Juni.)',
  'svip_introduce_text33': 'Jika nilai pengalaman SVIP Anda mencapai level yang lebih tinggi dalam satu bulan alami, nilai tersebut akan segera ditingkatkan. (Misalnya: jika Anda mencapai SVIP3 pada tanggal 18 Mei dan SVIP4 pada tanggal 25 Mei, Anda akan langsung memperoleh status SVIP4 pada tanggal 25 Mei dan berlanjut hingga akhir tanggal 30 Juni.)',
  'svip_introduce_text34': 'Ketika bulan alami berakhir, identitas dan hak istimewa akan dipertahankan, tetapi poin pengalaman SVIP untuk bulan berikutnya akan mulai diakumulasikan dari 0. (Misalnya: Jika Anda mencapai SVIP4 pada tanggal 25 Mei, Anda masih akan menikmati status dan hak SVIP4 sepanjang bulan Juni, namun Anda akan mulai mengumpulkan poin pengalaman SVIP dari 0 pada bulan Juni)',
  'svip_introduce_4': '4. Degradasi dan penurunan peringkat SVIP',
  'svip_introduce_text41': 'Di awal setiap bulan alami, jika Anda memiliki level SVIP dan ingin mempertahankan level SVIP ini di bulan berikutnya, Anda harus mencapai 50% dari nilai pengalaman level SVIP sebelum akhir bulan alami, yaitu Anda dapat mempertahankan level ini di bulan depan, lanjutkan identitas dan haknya. (Misalnya: ketika bulan Mei dimulai, Anda adalah SVIP4, maka Anda hanya perlu mencapai 50% nilai pengalaman level SVIP4 sepanjang bulan Mei untuk mempertahankan level SVIP4 hingga akhir Juni.)',
  'svip_introduce_text42': 'Jika 50% nilai pengalaman level SVIP tidak tercapai dalam satu bulan alami, maka akan dikurangi 1 level di bulan berikutnya. (Misalnya: awal bulan Mei Anda SVIP4, dan nilai pengalaman sepanjang bulan Mei tidak mencapai 50% dari level SVIP4, maka bulan Juni akan turun 1 level, dimulai dari SVIP3.)',
  'noble_introduce_title': 'Pengantar Aturan Mulia',
  'noble_introduce_welcome': 'Selamat bergabung dengan sistem aristokrat kami! Menjadi seorang bangsawan akan memungkinkan Anda menikmati lebih banyak hak istimewa dan manfaat unik. Berikut ini adalah pengenalan yang bermanfaat tentang sistem mulia kita:',
  'noble_introduce_1': '1.Apa itu bangsawan?',
  'noble_introduce_text1': 'Bangsawan merupakan simbol status khusus dan dibagi menjadi tujuh tingkatan status, yaitu ksatria, baron, viscount, earl, marquis, duke, dan king. Tingkat bangsawan yang berbeda menikmati hak istimewa yang berbeda.',
  'noble_introduce_2': '2. Bagaimana menjadi seorang bangsawan',
  'noble_introduce_text2': 'Bangsawan dapat dibeli dengan mengisi ulang koin emas, dan pembelian dapat diselesaikan dengan memilih level yang sesuai di halaman bangsawan. Di saat yang sama, Anda juga bisa memperoleh status mulia melalui hadiah dari orang lain.',
  'noble_introduce_3': '3. Perhitungan masa berlaku',
  'noble_introduce_text3': 'Status bangsawan berlaku selama 30 hari sejak tanggal pembelian, dan Anda akan menikmati hak istimewa mulia selama masa berlakunya. Hak istimewa tersebut akan kedaluwarsa pada akhir masa berlaku.',
  'noble_introduce_4': '4. Instruksi pengiriman koin harian',
  'noble_introduce_text4': 'Setelah membeli bangsawan melalui koin emas, Anda berhak menerima koin emas sebagai hadiah setiap hari. Anda akan menerima koin emas setelah masuk setiap hari. Jika Anda tidak masuk pada hari itu, Anda tidak akan bisa mendapatkan koin emas untuk hari itu. Saat menghadiahkan bangsawan kepada orang lain, penerima akan menerima hak untuk menerima koin harian.',
  'noble_introduce_5': '5. Diskon pembelian berkelanjutan',
  'noble_introduce_text5': 'Selama periode memperoleh status bangsawan, dan dalam waktu 10 hari setelah status bangsawan berakhir, status bangsawan yang sama dapat dibeli kembali dengan harga yang lebih menguntungkan. Paket ini tidak otomatis dan mengharuskan Anda membelinya secara manual agar dapat diterapkan.',
  'noble_introduce_6': '6. Peningkatan bangsawan',
  'noble_introduce_text6': 'Ketika Anda sudah memiliki status bangsawan, Anda dapat membeli bangsawan dengan level lebih tinggi dan langsung mendapatkan manfaat terbaru. Sisa hari bangsawan yang ada akan digabungkan ke level terbaru sesuai dengan nilai yang tersisa, dan masa berlaku bangsawan baru level akan diperpanjang.',
  'noble_introduce_7': '7. Hadiah dari bangsawan',
  'noble_introduce_text7': 'Saat memberikan bangsawan kepada orang lain, harga asli akan diberikan kepada orang lain, dan penerima akan menikmati koin harian dan hak lain yang sesuai dengan levelnya. Jika penerima sudah memiliki status bangsawan, dia akan langsung menikmati status bangsawan tingkat tinggi, dan level lainnya akan dikonversi sesuai dengan durasi yang sesuai.',
  'vip_introduce_title': 'Pengantar aturan VIP',
  'vip_introduce_welcome': 'Selamat menjadi VIP! VIP akan memungkinkan Anda menikmati lebih banyak hak istimewa. Berikut ini adalah pengenalan bantuan tentang VIP:',
  'vip_introduce_1': '1.Apa itu VIP',
  'vip_introduce_text1': 'VIP adalah sistem pertumbuhan pengguna. Saat ini ada 16 level, VIP-VIP6. Semakin tinggi level VIP, semakin banyak hak yang akan Anda nikmati dan semakin kaya propertinya.',
  'vip_introduce_2': '2.Bagaimana menjadi VIP',
  'vip_introduce_text2': 'Anda bisa mendapatkan poin pengalaman VIP dengan mengisi ulang koin emas, 1 koin emas = 1 poin pengalaman. Semakin banyak koin emas yang Anda isi ulang, semakin banyak poin pengalaman yang Anda dapatkan, dan VIP akan naik ke level yang lebih tinggi.',
  'vip_introduce_3': '3.Masa berlaku VIP',
  'vip_introduce_text3': 'Setelah status VIP diperoleh, status tersebut berlaku secara permanen, dan poin pengalaman VIP diakumulasikan secara permanen dan tidak akan dihapus. Saat poin pengalaman meningkat, Anda akan dipromosikan ke level VIP yang lebih tinggi dan menikmati lebih banyak manfaat level.',
  'vip_introduce_4': '4. Penggunaan alat peraga VIP',
  'vip_introduce_text4': 'Props level VIP yang Anda peroleh akan selalu disimpan di ransel Anda dan dapat dipakai kapan saja saat Anda melakukan upgrade, props level rendah yang Anda peroleh masih dapat digunakan.',
  'svip_introduce_title': 'Pengantar aturan SVIP',
  'svip_introduce_welcome': 'Selamat menjadi SVIP! SVIP akan memungkinkan Anda menikmati lebih banyak hak istimewa. Berikut ini adalah pengenalan SVIP yang bermanfaat:',
  'svip_introduce_text43': 'Jika tidak ada poin pengalaman SVIP yang dihasilkan dalam satu bulan alami, level SVIP akan turun 3 level di bulan berikutnya. (Misalnya: ketika bulan Mei dimulai, Anda SVIP4, dan tidak ada poin pengalaman yang dihasilkan sepanjang bulan Mei, maka bulan Juni akan turun 3 level, dimulai dari SVIP1)',
  'svip_introduce_5': '5. Hak dan kepentingan SVIP',
  'svip_introduce_text5': 'Semakin tinggi level SVIP, semakin banyak hak yang Anda nikmati. Saat level berubah, Anda akan menikmati manfaat dari level baru, dan hadiah prop yang Anda terima akan ditimpa oleh level baru. Saat meningkatkan atau memelihara prop yang disesuaikan, Anda perlu menghubungi layanan pelanggan sendiri dan mengajukan persyaratan penyesuaian sebelum dikeluarkan. Namun, prop tidak akan dikeluarkan jika Anda menurunkan level.',
  'svip_table1': 'tingkat SVIP',
  'vip_table1': 'tingkat VIP',
  'svip_table2': 'pesan gratis',
  'svip_table3': 'Panggilan gratis',
  'Anonymity_name': 'anonim',
  'Noble_Change_2': '1. Ketentuan pembelian: Item level rendah dapat dibeli dengan item level tinggi, tetapi item level tinggi tidak dapat dibeli dengan item level rendah. Misalnya: Jika Anda saat ini adalah seorang earl, pengguna hanya dapat membeli marquis, duke, dan king.',
  'Noble_Change_3': '2. Logika konversi: Jika Anda sudah menjadi bangsawan, setelah membeli bangsawan lain, masa berlaku bangsawan lama akan diubah menjadi bangsawan baru sebanding dengan harga koin emas, dan bangsawan lama akan menjadi tidak valid.',
  'Noble_Change_4': '3. Rumus perhitungan masa berlaku: Masa berlaku bangsawan yang baru dibeli = sisa hari bangsawan saat ini * (harga bangsawan saat ini/harga bangsawan yang dibeli) + 30, jumlah hari terakhir dibulatkan ke bawah',
  'Noble_Change_5': '4. Kasus: Saat ini saya adalah Viscount (99990 koin emas/bulan), dengan sisa 13 hari. Saya membeli earl (199990 koin emas/bulan) hari ini. Setelah pembayaran, earl berlaku selama 13*(99990/199990) +30=6,5 dibulatkan +30=36 hari',
  'rich_list': 'Daftar kaya',
  'lucky_list': 'Daftar keberuntungan',
  'lucky_daily': 'langit',
  'lucky_weekly': 'pekan',
  'lucky_faq1': 'Cara bermain',
  'lucky_faq2': 'Aturan permainan',
  'lucky_faq3': '1. Setelah mengirimkan hadiah keberuntungan, Anda berpeluang mendapatkan 1-1000 kali lipat hadiah koin emas;',
  'lucky_faq4': '2. Semakin banyak hadiah keberuntungan yang Anda kirimkan dalam bentuk Kombo atau batch, semakin besar peluang menang;',
  'lucky_faq5': '3. Hadiah koin emas akan didistribusikan ke saldo akun secara real time, dan detail kemenangan dapat dilihat di catatan hadiah keberuntungan;',
  'lucky_faq6': '4. Setiap kali hadiah keberuntungan diberikan, jangkar juga akan menerima berlian dalam jumlah tertentu.',
  'lucky_faq7': 'Daftar aturan',
  'lucky_faq8': '1. Aturan statistik',
  'lucky_faq9': 'Sepuluh pengguna yang menghabiskan koin emas paling banyak untuk berpartisipasi dalam gameplay harian dan mingguan akan masuk dalam daftar kaya, dan sepuluh pengguna dengan kelipatan kemenangan tertinggi akan masuk dalam daftar keberuntungan.',
  'lucky_faq10': '2. Siklus statistik',
  'lucky_faq11': 'Daftar harian: data mulai pukul 0:00 hingga 24:00 setiap hari',
  'lucky_faq12': 'Daftar mingguan: data mulai pukul 0:00 setiap Senin hingga pukul 24:00 pada hari Minggu',
  'lucky_faq13': '3. Buat daftar hadiah',
  'lucky_faq14': 'Sepuluh teratas dalam daftar harian dan mingguan akan menerima hadiah seperti yang ditunjukkan di bawah ini',
  'lucky_faq15': 'Hadiah peringkat harian',
  'lucky_faq16': 'Peringkat',
  'lucky_faq17': 'Hadiah peringkat mingguan',
  'Charge_Same_1': 'Anda telah melakukan pengisian ulang dengan jumlah yang sama kepada pengguna ini dalam waktu singkat dan telah dikreditkan.',
  'Charge_Same_2': 'Batalkan pembayaran',
  'Charge_Same_3': 'tetap harus membayar',
  'Registr_optimization_1': 'Masalah registrasi dan login',
  'AnchorCenter_biList_interaction_text1': 'interaktif',
  'AnchorCenter_biList_interaction_text2': 'Jumlah orang yang membangun aliansi (UV)',
  'AnchorCenter_biList_interaction_text3': 'Tingkat balasan (UV)',
  'AnchorCenter_biList_interaction_text4': 'Tingkat respons (PV)',
  'AnchorCenter_biList_interaction_text5': 'Tingkat respons (UV)',
  'AnchorCenter_biList_interaction_text6': 'Menerima pesan (uv)',
  'AnchorCenter_biList_interaction_text7': 'Balasan pesan (uv)',
  'AnchorCenter_biList_interaction_text8': 'Tingkat balasan (uv)',
  'AnchorCenter_biList_interaction_text9': 'Kirim pesan (uv)',
  'AnchorCenter_biList_interaction_text10': 'Pesan yang dibalas (uv)',
  'AnchorCenter_biList_interaction_text11': 'Tingkat balasan (uv)',
  'AnchorCenter_biList_interaction_text12': 'Kirim pesan (pv)',
  'AnchorCenter_biList_interaction_text13': 'Pesan yang dibalas (pv)',
  'AnchorCenter_biList_interaction_text14': 'Tingkat balasan (pv)',
  'AnchorCenter_biList_interaction_Popup1': 'Anda telah menerima pesan dari \'x\' pengguna',
  'AnchorCenter_biList_interaction_Popup2': 'Anda telah menerima pesan dari \'x\' pengguna, dan Anda telah membalas ke \'n\' pengguna.',
  'AnchorCenter_biList_interaction_Popup3': 'Contoh: Anda menerima informasi dari 100 pengguna, dan Anda secara efektif membalas 90 dari 100 pengguna tersebut. Tingkat respons efektif (UV) Anda = 90/100 = 90%.',
  'AnchorCenter_biList_interaction_Popup4': 'Persentase balasan pesan (UV)',
  'AnchorCenter_biList_interaction_Popup5': 'Tingkat balasan efektif: hanya menghitung jumlah pengguna yang tidak membalas dalam jangka waktu tertentu',
  'AnchorCenter_biList_interaction_Popup6': 'Jadi begitu',
  'AnchorCenter_biList_interaction_Popup7': 'Anda telah mengirimkan pesan yang tidak diminta ke \'x\' pengguna',
  'AnchorCenter_biList_interaction_Popup8': 'Di antara \'x\' pengguna yang Anda kirimi, \'n\' pengguna merespons Anda',
  'AnchorCenter_biList_interaction_Popup9': 'Persentase balasan dari pengguna lain (UV)',
  'AnchorCenter_biList_interaction_Popup10': 'Contoh: Anda secara proaktif mengirimkan informasi ke 100 pengguna, dan 50 dari 100 pengguna ini telah membalas Anda. Tingkat balasan efektif (UV) = 50/100 = 50%.',
  'AnchorCenter_biList_interaction_Popup11': 'Tingkat balasan efektif: hanya menghitung jumlah pengguna yang tidak membalas dalam jangka waktu tertentu',
  'AnchorCenter_biList_interaction_Popup12': 'Anda mengirim \'x\' pesan yang tidak diminta',
  'AnchorCenter_biList_interaction_Popup13': 'Dari \'x\' pesan yang Anda kirim secara inisiatif, \'n\' telah dibalas secara efektif.',
  'AnchorCenter_biList_interaction_Popup14': 'Persentase balasan dari pengguna lain (PV)',
  'AnchorCenter_biList_interaction_Popup15': 'Contoh: Anda secara proaktif mengirim 100 pesan, dan 70 dari 100 pesan ini dibalas secara efektif (PV)=70/100=70%.',
  'AnchorCenter_biList_interaction_Popup16': 'Tingkat balasan efektif: hanya menghitung jumlah pesan yang belum mencapai batas waktu balasan',
  'program_list_24_ios': 'Hapus',
  'withdraw_text_26': 'Harap verifikasi informasi pembayaran yang benar. Informasi yang salah akan mengakibatkan kegagalan penarikan, dan biaya tambahan akan ditanggung oleh pengguna.',
  'withdraw_text_29': 'petunjuk:',
  'withdraw_text_43': 'Ada pesanan yang belum selesai untuk metode pembayaran ini dan tidak dapat diubah atau dihapus sementara.',
  'withdraw_text_44': 'Berhasil dikirimkan!',
  'payment_bind_2': 'kartu bank',
  'payment_bind_2_GPAY': 'kartu bank',
  'payment_bind_3': 'nama Bank',
  'payment_bind_4': 'Nama',
  'payment_bind_5': 'Surat',
  'payment_bind_6': 'alamat',
  'payment_bind_7': '10 digit atau PL ditambah 10 digit',
  'payment_bind_8': 'Dimulai dengan TR + 24 digit',
  'payment_bind_9': '{n} Wajib',
  'payment_bind_10': 'berhasil dihapus',
  'payment_bind_11': 'Nama depan',
  'payment_bind_12': 'nama keluarga',
  'Tvwall_gift_9': 'Daftar keinginan hadiah lengkap senilai lebih dari atau sama dengan 2.000 koin emas untuk dipajang di dinding TV',
  'Tvwall_gift_10': 'Kondisi layar kunci pintu masuk:',
  'Tvwall_gift_32': 'Haruskah memberi hadiah ditampilkan di TV?',
  'Tvwall_gift_33': '(Klik untuk memilih agar segera diterapkan)',
  'Tvwall_gift_11': 'Kunci layar selama 10 detik: hadiah keinginan selesai dan nilai hadiah keinginan antara 2000 koin emas dan 9999 koin emas;',
  'Tvwall_gift_12': 'Layar kunci selama 20 detik: Menyelesaikan hadiah keinginan dan nilai hadiah keinginan antara 10.000 koin emas dan 49.999 koin emas;',
  'Tvwall_gift_13': 'Layar kunci selama 60 detik: Menyelesaikan hadiah permintaan dan nilai hadiah permintaan lebih dari 50.000 koin emas',
  'Tvwall_gift_14': 'Ketentuan untuk tampil di Tembok TV Dunia:',
  'Tvwall_gift_15': 'Catatan biasa: Menyelesaikan hadiah keinginan dan nilai hadiah keinginan adalah antara 2000 koin emas dan 9999 koin emas',
  'Tvwall_gift_16': 'Catatan mewah: Menyelesaikan hadiah permintaan dan nilai hadiah keinginan lebih besar dari atau sama dengan 10.000 koin emas',
  'Tvwall_gift_17': 'Di dinding TV',
  'Tvwall_gift_18': 'Anonim di dinding TV',
  'Tvwall_gift_19': 'Bukan di dinding TV',
  'Admob_text7': 'Dalam persiapan',
  'Admob_text8': 'Video belum siap',
  'EXP': 'EXP',
  'Experience_Card_Statement': '*Kartu pengalaman tidak memiliki manfaat ini',
  'Official_website_payment_1': 'Isi Ulang Online Soyou',
  'Official_website_payment_2': 'ID isi ulang',
  'Official_website_payment_3': 'Masukkan IDnya',
  'Official_website_payment_4': 'apa itu tanda pengenal?',
  'Official_website_payment_5': 'Silakan periksa terlebih dahulu untuk melindungi privasi dan keamanan akun.',
  'Official_website_payment_6': 'Pertanyaan',
  'Official_website_payment_7': 'Instruksi pengguna',
  'Official_website_payment_8': '1. Mohon jangan membeli koin Soyou melalui situs web tidak resmi atau tidak sah untuk menghindari perselisihan yang tidak perlu.',
  'Official_website_payment_9': '2. Mohon jangan percaya informasi tidak resmi yang dipublikasikan di situs web, saluran komunikasi, atau grup komunikasi lain. Semua informasi acara harus tunduk pada situs web resmi atau pengumuman di sistem.',
  'Official_website_payment_10': '3. Tidak mendukung transaksi offline apa pun.',
  'Official_website_payment_11': '4. Mohon untuk tidak mengungkapkan informasi akun Anda kepada orang lain dengan alasan dan cara apa pun.',
  'Official_website_payment_12': '5. Soyou tidak bertanggung jawab atas perselisihan antara pengguna dan pihak ketiga.',
  'Official_website_payment_13': '6. Jika Anda mengalami masalah pengisian daya, silakan hubungi layanan pelanggan atau email kami.',
  'Official_website_payment_14': 'Anti pencucian uang',
  'Official_website_payment_15': '1. Pengguna harus memastikan bahwa mereka memiliki identitas hukum dan kapasitas untuk menggunakan layanan yang kami sediakan, dan tidak akan berpartisipasi atau dikaitkan dengan aktivitas kriminal apa pun.',
  'Official_website_payment_16': '2. Akun pengguna hanya untuk penggunaan pribadi Anda dan milik Anda secara pribadi. Anda tidak boleh mentransfer, menyewakan, atau membuang akun Anda kepada pihak ketiga mana pun.',
  'Official_website_payment_17': '3. Pengguna harus memastikan bahwa seluruh dana yang digunakan untuk pengisian ulang diperoleh melalui jalur yang sah dan tidak terkait dengan kegiatan atau perilaku kriminal sewaktu-waktu.',
  'Official_website_payment_18': 'Metode pembayaran',
  'Official_website_payment_19': 'Saat ini menggunakan saluran pembayaran {%s}',
  'Official_website_payment_20': 'Opsi isi ulang',
  'Official_website_payment_21': 'Mengubah',
  'Official_website_payment_22': 'ID Akun tidak ada!',
  'Official_website_payment_23': 'Belum ada metode pembayaran yang didukung',
  'Official_website_payment_24': 'Umpan balik metode pembayaran yang Anda inginkan',
  'Official_website_payment_25': 'Menanyakan hasil transaksi',
  'Official_website_payment_26': 'Hasil isi ulang harus dikonfirmasi',
  'Official_website_payment_27': 'Hasil isi ulang mungkin tertunda. Silakan masuk ke Aplikasi untuk memeriksa catatan isi ulang akun. Jika akun tidak sampai dalam waktu lama, silakan hubungi layanan pelanggan.',
  'Official_website_payment_28': 'menyegarkan',
  'Official_website_payment_29': 'Gagal mengisi ulang',
  'Official_website_payment_30': 'Informasi bantuan:',
  'Official_website_payment_31': '1. Harap konfirmasi apakah jumlah dan metode pembayaran sudah benar, termasuk informasi pribadi, nomor kartu kredit, masa berlaku, kode CVV, dll.',
  'Official_website_payment_32': '2. Silakan periksa apakah saldo rekening mencukupi.',
  'Official_website_payment_33': '3. Periksa apakah koneksi jaringan stabil. Terkadang masalah jaringan dapat menyebabkan kegagalan pembayaran.',
  'Official_website_payment_34': '4. Coba ubah ke metode pembayaran lain atau coba isi ulang nanti.',
  'Official_website_payment_35': '5. Jika masalah masih belum teratasi, disarankan untuk menghubungi layanan pelanggan platform isi ulang untuk bantuan lebih lanjut.',
  'Official_website_payment_36': 'Isi ulang berhasil',
  'Official_website_payment_37': 'Silakan masuk ke Aplikasi untuk melihat catatan isi ulang akun',
  'Official_website_payment_38': 'Batas waktu tautan gagal',
  'Official_website_payment_39': 'Tautan telah kedaluwarsa. Harap buat ulang tautan pembayaran di Aplikasi.',
  'payment_bind_13': 'Contract Address',
  'payment_bind_14': 'Epay Email',
  'payment_bind_15': 'Note: TRC-20 protocol',
  'payment_bind_16': 'Note: Ensure your Epay account is verified',
  'payment_bind_17': 'Contract address starts with T',
  'payment_bind_18': 'Cannot exceed 40 characters',
  'payment_bind_19': 'Must match your Epay account email',
  'payment_bind_20': 'Enter email address',
  'payment_bind_21': 'Gcash account',
  'payment_bind_22': 'Must be 11 digits starting with 09',
  'payment_bind_23': 'Only allow English letters, spaces, hyphens (-), periods (.), and commas (,) and less than 100 characters.',
  'payment_bind_24': 'Bank Tansfer account',
  'payment_bind_25': 'Pix Key (CPF/CNPJ)',
  'payment_bind_26': 'Document',
  'payment_bind_27': 'Hanya 11 digit yang diizinkan',
  'task_miss': 'merindukan',
  're_signing': 'Penandatanganan ulang',
  'anchor_task_txt1': 'Kunjungi teman lama (dan dapatkan balasan dari mereka) sebanyak ({%s1}) kali dan dapatkan ({%s2}) berlian',
  'anchor_task_txt2': 'Jumlah sesi dengan pengguna baru >5, mencapai ({%s1}) kali, dan mendapatkan ({%s2}) berlian',
  'task_txt21': 'Check-in harian',
  'task_txt22': 'langit',
  'task_txt23': 'Masuk',
  'task_txt24': 'daftar tugas',
  'task_txt25': 'Tugas jangkar',
  'task_txt31': 'Masuk',
  'sign_in_text3_new': 'Masuk 2x lipat reward',
  'Double_Rewards_text1': 'Jadilah SVIP untuk Hadiah Ganda!',
  'family.level.instructions': 'INSTRUKSI TINGKAT KELUARGA',
  'family.division.privilege': 'Divisi & Keistimewaan Divisi',
  'family.division.privilege.describe': 'Pembagian didasarkan pada exp bulanan, direset pada tanggal 1 setiap bulannya. Divisi dapat meningkatkan, mempertahankan, dan menurunkan versi. Mempertahankan peringkat saat ini hanya memerlukan pencapaian 100% dari exp peningkatan yang sesuai.',
  'family.diamonds.exch': 'Berlian Exch.',
  'family.new.diamonds.exch': 'Lencana',
  'family.label.tag': 'Tag Keluarga',
  'family.label.frame': 'Bingkai Keluarga',
  'family.label.chatroom': 'Ruang Obrolan Bg',
  'family.label.familyBg': 'Keluarga Bg',
  'family.bronze.family': 'Keluarga Perunggu',
  'family.silver.family': 'Keluarga Perak',
  'family.golden.family': 'Keluarga Emas',
  'family.diamond.family': 'Keluarga Berlian',
  'family.king.family': 'Keluarga Raja',
  'family.task.daily.exp': 'PENGALAMAN HARIAN',
  'family.task.monthly.exp': 'EXP BULANAN',
  'family.task.exp.describe': 'EXP yang Anda sumbangkan ke keluarga',
  'family.task.tips': 'Selesaikan tugas dalam 2 hari pertama setelah bergabung dengan Keluarga untuk mendapatkan pengalaman ganda.',
  'family.task.invite.join': 'Undang Teman untuk Bergabung dengan Keluarga',
  'family.task.treasure.unlocked': 'Jika jumlah anggota mencapai %s, kotak harta keluarga akan terbuka pada pukul 00.00 setiap hari',
  'family.task.your.rewards': 'Hadiah Anda',
  'family.task.rules.first': 'Setelah memenuhi syarat peti harta karun keluarga, hadiah di peti harta karun akan dibuka secara acak.',
  'family.task.rules.second': 'Anggota yang menyelesaikan tugas sebelum peti harta karun dibuka akan menerima hadiah.',
  'family.task.rules.three': 'Item akan didistribusikan ke Winners Bag, dan hadiah lainnya seperti EXP atau koin akan didistribusikan ke akun.',
  'family.task.rules.four': 'Hadiah akan didistribusikan secara otomatis setelah peti harta karun dibuka',
  'family.task.captain.task': 'Tugas Kapten',
  'family.task.treasure.chest': 'Peti Harta Karun Keluarga',
  'family.task.interactive': 'Tugas Interaktif',
  'family.task.cumulative': 'Tugas Akumulatif',
  'family.task.others': 'Lainnya',
  'family.task.family.level': 'Level Keluarga didasarkan pada akumulasi exp. Setiap level sesuai dengan hak istimewa berikut.',
  'family.exp.title': 'Pengalaman Keluarga',
  'family.exp.content.title.1': 'Bagaimana cara mendapatkan EXP Keluarga?',
  'family.exp.content1.text.title.1': 'Anggota keluarga mengirim hadiah',
  'family.exp.content1.text.1': '10 Koin',
  'family.exp.content1.text.2': '1 EXP',
  'family.exp.content1.text.3': '50 Gem',
  'family.exp.content1.text.title.2': 'Anggota keluarga menerima hadiah',
  'family.exp.content1.text.title.3': 'Menyelesaikan tugas keluarga',
  'family.exp.content.title.2': 'Level Keluarga & Keistimewaan level',
  'family.exp.table.title.1': 'Pengalaman / EXP',
  'family.exp.table.title.2': 'Anggota',
  'family.exp.table.title.3': 'Wakil Kapten',
  'family.exp.table.title.4': 'Admin',
  'common.EXP': 'EXP',
  'game.task.center.get': 'Dapatkan',
  'game.task.center.received': 'Diterima',
  'coupon_pay_txt4': 'Koin',
  'coupon_pay_txt2': 'Hanya Untuk {%S}',
  'coupon_pay_txt3': '{%S}% Kupon Koin',
  'iosso_wallet_txt8': 'Go Back',
  'common.up.SECS': 'DETIK',
  'recharge.event.Recharge': 'Isi ulang',
  'recharge.event.hidden': 'Sembunyikan informasi',
  'report.option.child': 'Patali budak',
  'lucky.vs.camp.select': 'Pilihan Perkemahan',
  'lucky.vs.camp.select.text.1': 'Top 5 Kontributor dari Perkemahan dapat mendapatkan coins',
  'lucky.vs.camp.select.text.2': 'Perkemahan mana yang anda ingin gabung?',
  'lucky.vs.camp.select.text.3': 'TIPS : Setiap user hanya memiliki satu kesempatan untuk merubah Perkemahan selama periode event.',
  'lucky.vs.camp.edit.text.1': 'Ubah Perkemahan',
  'lucky.vs.camp.edit.text.2': 'Apakah anda yakin ingin merubah Perkemahan? Setiap user hanya memiliki satu kesempatan untuk merubah Perkemahan selama periode event.',
  'lucky.vs.camp.edit.text.3': 'Ya',
  'lucky.vs.camp.edit.text.4': 'Tidak',
  'lucky.vs.camp.opponent': 'Perkemahan Lawan',
  'lucky.vs.camp.me': 'Perkemahan Kami',
  'lucky.vs.camp.join': 'Bergabung',
  'lucky.vs.camp.Eagle': 'Peringkat Elang',
  'lucky.vs.camp.Lion': 'Peringkat Singa',
  'lucky.vs.out.tab.left': 'Kotak Harta Karun',
  'lucky.vs.out.tab.right': 'Elang vs Singa',
  'lucky.vs.reward.extra': 'Hadiah Elang vs Singa',
  'lucky.vs.ext.text.tip': 'Dapatkan {N} coins untuk mendapatkan hadiah berikut',
  'world.cup.records': 'Catatan',
  'kill.monster.congratulations': 'Selamat!',
  'world.cup.time': 'Waktu',
  'common.cap.Rewards': 'Hadiah',
  'common.number': 'Nomor',
  'activity.gift.list.contributor': 'Peringkat Kontributor',
  'activity.gift.list.stars': 'Peringkat Bintang',
  'activity.gift.list.send': 'Kontributor',
  'activity.gift.list.receive': 'Bintang',
  'common.cap.Rights': 'Semua Hak Dilindungi Oleh',
  'biu.biu.building.ranking.list': 'Daftar peringkat',
  'biu.biu.building.car.detail': 'Detail kendaraan',
  'biu.biu.building.detail.coin': '{$month}-{$day} {$hour}:{$min}, Anda mengisi ulang {$coin} koin.',
  'biu.biu.building.detail.floors.one': '{$month}-{$day} {$hour}:{$min}, Anda melawan {$count} {$level} {$cars} dan menghancurkan {$floornumer} {$floor}.',
  'biu.biu.building.rush.button': 'Go*{$times}',
  'biu.biu.building.can.rush.one': 'Waktu Sibuk yang Tersisa: Mobil Level 1*{$times}',
  'biu.biu.building.can.rush.two': 'Mobil Level 2*{$times}',
  'biu.biu.building.one.car': 'Mobil Level 1',
  'biu.biu.building.two.car': 'Mobil Level 2',
  'biu.biu.building.to.war': 'Go',
  'biu.biu.building.recharge': 'Isi ulang {$value}koin/{$count} kali',
  'biu.biu.building.daily.list': 'Daftar harian',
  'biu.biu.building.all.list': 'Daftar keseluruhan',
  'biu.biu.building.car.not.enough': 'Jumlah kendaraan saat ini tidak mencukupi',
  'biu.biu.building.to.get': 'mendapatkan',
  'biu.biu.building.congra': 'Selamat!',
  'biu.biu.building.to.collect': 'OK',
  'biu.biu.building.get.reward': 'Hadiahmu!',
  'biu.biu.building.ruls.reward': 'Hadiah aturan',
  'biu.biu.building.no.records': 'Tidak ada catatan',
  'biu.biu.building.no.lucky': 'sial',
  'biu.biu.building.no.start': 'Tahap ini akan dimulai',
  'biu.biu.building.floor.single': 'Lantai',
  'biu.biu.building.floor.double': 'Lantai',
  'biu.biu.building.car.single': 'Mobil',
  'biu.biu.building.car.double': 'Mobil',
  'annual.poly.wating': 'Menonton',
  'annual.ranking.surprise.store': 'Toko Kejutan',
  'annual.ranking.daily.task': 'Tugas sehari hari',
  'annual.ranking.ticket': 'Tiket',
  'annual.ranking.daily.ranking': 'Peringkat Harian',
  'annual.ranking.total.ranking': 'Peringkat Total',
  'annual.ranking.current.tickets': 'Tiket Saat Ini',
  'annual.ranking.points': 'Poin',
  'annual.ranking.open': 'Membuka',
  'annual.ranking.collect': 'Kumpulkan',
  'annual.ranking.unfinished': 'Belum selesai',
  'annual.ranking.exchange': 'Tukarkan',
  'annual.ranking.confirm': 'Konfirmasi',
  'annual.ranking.to.bag': 'Barang yang ditukar dapat dilihat di dalam tas',
  'annual.ranking.exchange.maximum': 'Jumlah pertukaran mencapai maksimum hari ini',
  'annual.ranking.limited': 'Terbatas',
  'annual.ranking.slod.out': 'TERJUAL HABIS',
  'annual.ranking.stock': 'Saham',
  'annual.ranking.return': 'Kembali',
  'annual.ranking.fortune.wheel': 'Roda Keberuntungan',
  'annual.ranking.record': 'Histori',
  'annual.ranking.exchange.amount': 'Nilai Tukar',
  'annual.draw.1.time': 'Putar {N}x',
  'annual.draw.10.time': 'Putar {N}x',
  'annual.draw.record.text': 'Selamat! Anda telah menerima',
  'annual.draw.pop.to.get': 'MENDAPATKAN',
  'annual.draw.pop.no.times': 'Waktu pengundian tidak mencukupi',
  'annual.draw.pop.no.record': 'Belum ada histori',
  'annual.draw.pop.rewards.title': 'Selamat!',
  'annual.draw.pop.oppos': 'Maaf!',
  'annual.ranking.union.achor': 'Host Tahunan',
  'annual.ranking.union.agency': 'Agency Tahunan',
  'annual.ranking.union.target': 'Target',
  'annual.ranking.task.confirm': 'Apakah Anda yakin menikmati mode {$count}x poin sekarang?',
  'annual.ranking.union.id': 'ID Agensi:',
  'annual.ranking.icon': 'Ikon',
  'annual.ranking.num': 'Angka',
  'annual.ranking.success': 'Berhasil',
  'common.cap.Go': 'Mulai',
  'common.cap.Follow': 'Ikuti',
  'gift.list.plus.up.need': 'Naik Diperlukan',
  'spring.cp.rewards.wedding.tips': '2 User yang menyelenggarakan pernikahan akan mendapatkan limited avatar*30 hari',
  'spring.cp.tab.rose.ranking': 'Ranking Rose',
  'spring.cp.tab.rose.ranking.daily': 'Ranking Harian',
  'spring.cp.tab.rose.ranking.daily.toast': 'Pasangan belum hadir',
  'spring.cp.tab.rose.ranking.daily.tips': 'Kirim gift ini akan mendapatkan {%d}% ekstra rose hari ini',
  'spring.cp.tab.rose.ranking.total': 'Ranking Total',
  'spring.cp.tab.cruise.ranking': 'Pernikahan Kapal Pesiar',
  'spring.cp.no.people': 'Waiting',
  'spring.cp.no.cp': 'kamu tidak mengirim gift limited',
  'spring.cp.wait.wedding': 'Pernikahan dimulai pada 14 Februari',
  'spring.cp.cruise.rule.tips': 'CP dengan rose terbanyak dengan saling mengirim gift limited selama event akan menjadi tuan rumah Pernikahan Kapal Pesiar pada tanggal 2.14',
  'spring.cp.cruise.my.cp': 'CP ku',
  'spring.cp.cruise.find.my.cp': 'Temukan CP ku',
  'spring.cp.cruise.bless': 'Tekan untuk Bless',
  'spring.cp.cruise.bless.my.times': 'Kelipataku',
  'spring.cp.cruise.bless.status.1': 'Diterima',
  'spring.cp.cruise.bless.status.2': 'Belum diambil',
  'spring.cp.cruise.bless.click.desc': 'Tekan {N} kali akan dapat {name} {time}',
  'common.cap.Start': 'Mulai',
  'common.cap.Close': 'Tutup',
  'common.cap.next.round': 'Ronde berikutnya akan segera datang...',
  'ramadan.new.waiting': 'Menunggu',
  'ramadan.new.rank.tab.receive': 'Ranking Charming',
  'ramadan.new.rank.tab.give': 'Ranking Wealth',
  'ramadan.new.rank.daily': 'Ranking Harian',
  'ramadan.new.rank.total': 'Ranking Total',
  'ramadan.new.rank.daily.desc': 'TOP1 user harian akan mendapatkan hadiah berikut.',
  'ramadan.new.rank.tips': 'Stage ini akan dimulai',
  'ramadan.new.honor.times': '{n}kali',
  'ramadan.new.honor.time': '{n}kali',
  'ramadan.new.honor.countdown.waiting': 'Event akan dimulai',
  'ramadan.new.honor.countdown.ing': 'Countdown',
  'ramadan.new.honor.countdown.over': 'Event berakhir',
  'ramadan.new.honor.desc': 'Room honor pop-up akan muncul 1x setiap {N} gift limited terkirim di seluruh platform.',
  'ramadan.new.honor.toTop1.time': 'NAIK BUTUH <span class=\'span\'> {N} </span> NAIK',
  'ramadan.new.honor.toTop1.times': 'NAIK BUTUH <span class=\'span\'> {N} </span> NAIK',
  'ramadan.new.honor.my.times': 'Kali ku',
  'ramadan.new.event.start': 'Event akan dimulai',
  'ramadan.new.my.tickets': 'Tiketku',
  'ramadan.new.estimated.win': 'Kemungkinan menang',
  'ramadan.new.prize.content': 'Kamu mendapatkan',
  'ramadan.new.collect': 'Ambil',
  'ramadan.new.tab1': 'Ramadan Sign-In',
  'ramadan.new.sign.day': 'Sign-In {N} hari',
  'ramadan.new.collected': 'Sudah Diambil',
  'ramadan.new.today.content': 'Sign-in hari ini untuk dapat:',
  'ramadan.new.ok': 'OK',
  'ramadan.new.bottom.desc': 'Top up sehari sekali dan kamu dapat re-sign lagi 1x',
  'ramadan.new.resign.btn': 'Re-sign in',
  'ramadan.new.resign.content': 'Sukses re-signing dapat:',
  'ramadan.new.resign.fail.content': 'Top up sehari sekali dan kamu dapat re-sign lagi 1x. (Coin yang di top up melalui official coinseller akan terhitung; Jika coinseller top up untuk saldo coinseller tidak terhitung).',
  'ramadan.new.resign.fail.btn': 'Top up sekarang',
  'ramadan.new.tab2': 'Ranking Prayer',
  'ramadan.new.tab3': 'Blessing Honor',
  'ramadan.new.next': 'NEXT',
  'ramadan.new.back': 'Kembali',
  'ramadan.new.not.remain': 'Jangan munculkan lagi.',
  'ramadan.new.had.sign': 'Kamu sudah sign-in lagi hari ini',
  'ramadan.new.nickname': 'Nama',
  'lasser.bairam.collect': 'Ambil',
  'lasser.bairam.ok': 'OK',
  'lasser.bairam.waiting': 'Menunggu',
  'lasser.bairam.special.gift.title': 'welfare treasure box',
  'lasser.bairam.special.gift.to.be.drawn': 'Untuk Draw',
  'lasser.bairam.special.gift.to.complete': 'Selesaikan Sekarang',
  'lasser.bairam.special.gift.contribution': 'Chest Kontribusi',
  'lasser.bairam.special.gift.lucky': 'Lebaran Hoki Chest',
  'lasser.bairam.special.gift.desc': 'Accumulated limited gift value received {%d} coins can participate in the selection of lucky stars ({%z}/{%m})',
  'lasser.bairam.tab.scene': 'Trip idul fitri',
  'lasser.bairam.tab.ranking': 'Ranking',
  'lasser.bairam.scene.tips': 'Kirim gift limited dan capai target coin untuk membuka scene dan dapatkan hadiah. MVP akan dapat tambahan hadiah.',
  'lasser.bairam.scene.rewards.desc': 'Setelah berpatisipasi untuk membuka scene saat ini, kamu akan mendapatkan hadiah berikut, dan untuk MVP akan mendapatkan hadiah tambahan',
  'lasser.bairam.scene.unlock.modal.title': 'Selamat dalam partisipasi membuka lokasi:',
  'lasser.bairam.scene.unlock.modal.you.can.get': 'Bisa dapat',
  'lasser.bairam.scene.unlock.modal.mvp.tag': 'MVP bisa dapat',
  'lasser.bairam.rewards.tips': 'Untuk detil dapatkan coin, silakan cek halaman peraturan',
  'lasser.bairam.go.look': 'Cek Sekarang!',
  'lasser.bairam.no.time.yet': 'Belum waktunya',
  'lasser.bairam.next.round': 'Next round',
  'lasser.bairam.ranking.tab.send': 'Wealth Ranking',
  'lasser.bairam.ranking.tab.receive': 'Charm Ranking',
  'lucky.darw.title': 'Undian Keberuntungan',
  'lucky.draw.tab.ranking': 'Ranking',
  'lucky.draw.exchange.shop': 'Toko Tiket',
  'lucky.draw.exchange.shop.val': 'Value Coin{%d}',
  'lucky.draw.exchange.shop.exchange': 'Tukar',
  'lucky.draw.my.times': 'Putaranku',
  'lucky.draw.rare': 'Langka',
  'lucky.draw.exchange.records': 'Histori',
  'lucky.draw.exchange.records.time': 'Waktu',
  'lucky.draw.exchange.records.consume': 'Menggunakan',
  'lucky.draw.exchange.records.commodity': 'Komoditas',
  'lucky.draw.confirm': 'Konfirmasi',
  'lucky.draw.confirm.text': 'Yakin menggunakan {%d} tiket untuk menukar?',
  'lucky.draw.confirm.success': 'Sukses',
  'lucky.darw.ruls.1': 'Kirim hadiah di dalam ruangan obrolan dan dapatkan kesempatan untuk masuk undian',
  'lucky.darw.ruls.2': 'Setiap 5000 koin senilai hadiah memberi Anda 1 undian',
  'lucky.darw.ruls.3': 'Contoh: 50.000 koin = 10 undian, 100.000 koin = 20 undian. Kirim lebih banyak hadiah untuk mendapatkan lebih banyak undian.',
  'lucky.darw.ruls.4': 'Jika hari berakhir dan Anda tidak menggunakan undian Anda, semua undian Anda akan menjadi 0 setelah acara selesai.',
  'lucky.darw.number': 'Jumlah undian saya',
  'lucky.darw.reset.time': 'WAKTU RESET',
  'lucky.darw.ranking': 'Peringkat Undian',
  'lucky.darw.use': 'PERGI UNTUK MENGGUNAKAN',
  'lucky.darw.no.times': 'Jumlah undian saat ini tidak cukup, pergi ke ruangan dan kirim hadiah',
  'lucky.darw.coin.one.times': 'Harga mengundi sekali',
  'lucky.darw.coin.draw': 'Undi',
  'lucky.darw.coin.more.times': 'Biaya per kali',
  'lucky.darw.coin.more.will.cost': 'akan menghabiskan',
  'lucky.draw.rules.1': 'At the end of the event, the top three winners will receive the following prizes',
  'lucky.draw.rules.2': 'note: At the end of the campaign, the number of unused prizes will become 0',
  'common.cap.Success': 'Berhasil',
  'family.football.no.tips': 'Tidak ada tips lagi untuk berikutnya',
  'common.cap.Record': 'Histori',
  'coins.battle.time': 'kali',
  'coins.battle.times': 'kali',
  'coins.battle.draw.total.coins': 'Akumulasi:<span class=\'num\'>{totalRechargeCoins}</span>Coin',
  'coins.battle.draw.remain.times': 'Sisa draw: {remainTime} kali',
  'coins.battle.draw.no.recharge': 'Hanya top up {coinToDrawCount} coin untuk pertama kali.',
  'coins.battle.draw.recharged': 'Akumulasi top up {coinToDrawCount} coin: Kesempatan Draw +1',
  'coins.battle.draw.drawing.tips': 'Tips draw',
  'coins.battle.draw.drawing.tips.desc': 'Draw tidak cukup! top up sekarang untuk dapatkan draw!',
  'coins.battle.draw.drawing.tips.recharge.now': 'Top up sekarang',
  'coins.battle.task.title': 'Area tampilan task',
  'coins.battle.task.go': 'Go',
  'coins.battle.task.completed': 'Selesai',
  'coins.battle.task.tips': 'Setiap task yang kamu selesaikan akan mendapatkan kesempatan draw',
  'coins.battle.entry.title': 'Kejutan not keiutan',
  'coins.battle.entry.desc': 'Kamu memiliki 1 kesempatan untuk draw coin hingga 1juta!',
  'coins.battle.entry.btn': 'Top uo {coinToDrawCount} coin untuk dapat',
  'coins.battle.rules.not.show.again': 'Jangan munculkan lagi',
  'coins.battle.result.title': 'Selamat!',
  'coins.battle.result.prize.pool': 'Dapat {N}% coin dari prize pool',
  'coins.battle.result.get': 'Get',
  'coins.battle.record.tab.draw.record': 'Histori draw',
  'coins.battle.record.tab.number.of.draws': 'Jumlah Draw',
  'coins.battle.record.head.time': 'Kali',
  'coins.battle.record.head.coins.or.tasks': 'Coin/Task',
  'coins.battle.record.complete.task': 'Task selesai {N}',
  'common.cap.Coins': 'Koin',
  'common.cap.time': 'waktu',
  'common.cap.times': 'Putaran',
  'common.cap.my.times': 'Jumlah undian saya',
  'common.cap.Sure': 'TENTU',
  'common.cap.not.remind': 'Tidak ada lagi pengingat',
  'lucky.draw.may.tab.draw': 'Mecha draw',
  'lucky.draw.may.tab.vote': 'Mecha Star',
  'lucky.draw.may.tab.ranking': 'Peringkat',
  'lucky.draw.may.draw.draw.times': 'seri*{%d}',
  'lucky.draw.may.draw.draw.tips': 'mengirimkan hadiah terbatas sebesar {%d} koin dapat memperoleh kesempatan mengundi',
  'lucky.draw.may.confirm.text': 'Yakin mengeluarkan {%s} x{%d} untuk mengundi?',
  'lucky.draw.may.vote': 'Pilih',
  'lucky.draw.may.vote.top3.title': 'top3 rewards',
  'lucky.draw.may.vote.top3.tips': 'rincian hadiah lebih lanjut silakan temukan di halaman aturan',
  'lucky.draw.may.vote.please.enter.id': 'Silakan masukkan identitas',
  'lucky.draw.may.vote.tips': 'mengirim hadiah terbatas sebesar {%d} koin dapat memperoleh 1 tiket',
  'lucky.draw.may.vote.search.tips': 'Hanya host yang dapat dipilih',
  'lucky.draw.may.vote.cur.ranking': 'peringkat saat ini：{%d}',
  'lucky.draw.may.vote.voting.record': 'Rekor pemungutan suara',
  'lucky.draw.may.vote.voting.record.user': 'pengguna',
  'lucky.draw.may.vote.voting.record.number': 'jumlah suara',
  'lucky.draw.may.rewards.tips': 'Untuk aturan rinci tentang cara mendapatkan hadiah, silakan buka halaman aturan',
  'lucky.draw.may.unlock': 'Membuka',
  'lucky.draw.may.unlock.some': 'selamat telah membuka {%s}%,Ambil hadiah ini～',
  'lucky.draw.may.unlock.all': 'Terima kasih telah membuka semua teka-teki, ambil semua hadiah',
  'lucky.draw.may.result.tips': '{%s} akan digunakan untuk membuka kunci teka-teki',
  'common.cap.confirm': 'Confirm',
  'common.cap.cancel': 'Cancel',
  'common.cap.month1': 'Jan',
  'common.cap.month2': 'Feb',
  'common.cap.month3': 'Mar',
  'common.cap.month4': 'Apr',
  'common.cap.month5': 'Mei',
  'common.cap.month6': 'Jun',
  'common.cap.month7': 'Jul',
  'common.cap.month8': 'Agu',
  'common.cap.month9': 'Sept',
  'common.cap.month10': 'Okt',
  'common.cap.month11': 'Nov',
  'common.cap.month12': 'Des',
  'fes.of.sa.not.start': 'Event akan dimulai',
  'fes.of.sa.tab1': 'Tantangan Bakar Kambing',
  'fes.of.sa.tab2': 'Kambing Kabur',
  'fes.of.sa.free': 'GRATIS!',
  'fes.of.sa.collect.tools': 'Kumpulkan bahan untuk Bakar Kambing',
  'fes.of.sa.combine': 'Combine',
  'fes.of.sa.count': 'X{N}',
  'fes.of.sa.ranking': 'Peringkat',
  'fes.of.sa.tip.text': 'Kamu punya lebih dari {N} kambing untuk dicombine, combine sekarang?',
  'fes.of.sa.ok': 'OK',
  'fes.of.sa.records': 'Histori',
  'fes.of.sa.draw': 'draw*{%d}',
  'fes.of.sa.ticket.enough': 'tiket tidak cukup, kirim gift untuk dapatkan tiket!',
  'fes.of.sa.draw.again': 'Draw lagi',
  'fes.of.sa.time': 'Waktu',
  'fes.of.sa.recharge.btn': 'Top Up',
  'fes.of.sa.send.btn': 'Kirim',
  'fes.of.sa.rank.tab1': 'Ranking Bakar Kambing',
  'fes.of.sa.rank.tab2': 'Charm',
  'fes.of.sa.rank.daily': 'Harian',
  'fes.of.sa.rank.total': 'Total',
  'fes.of.sa.lamb.top': 'Tangkap kambing gratis, dapat 5x point ranking!',
  'fes.of.sa.unlock.btn': 'KIRIM GIFT UNTUK UNBLOCK',
  'fes.of.sa.wait.lock': 'AKAN TERBUKA!',
  'fes.of.sa.catch.btn': 'Dapat ({N})',
  'fes.of.sa.lamb.rewards': 'GIFT GRATIS DARI KAMBING KABUR',
  'fes.of.sa.catch.suc.title': 'Tangkap Sukses!',
  'fes.of.sa.catch.suc.text': 'Selamat! Kamu dapat 1 Kambing gratis! kambing gratis dari kambing kabur akan terhitung 5x point di Ranking Kambing!',
  'fes.of.sa.catch.cong.title': 'Selamat!',
  'fes.of.sa.catch.cong.text': 'Gagal menangkap kambing, kami berikan harapan semoga lain kali hoki dan gift lainnya!',
  'fes.of.sa.catch.oops': 'Oops..',
  'fes.of.sa.catch.oops.text': 'Yah gagal dapat hadiah. TalkTalk doakan semoga hoki lain kali yah',
  'fes.of.sa.event.gift': 'Gift Limited',
  'game.king.prize.pool': 'पुरस्कार राशि',
  'game.king.tab1': 'सिंहासन विवाद',
  'game.king.tab2': 'बहादुर ड्रैगन द्वीप',
  'game.king.game.king': 'गेम किंग',
  'game.king.bounds.gold': 'बोनस गोल्ड',
  'game.king.score': 'स्कोर',
  'game.king.king.desc': 'इस राउंड के अंक',
  'game.king.king.reward': 'किंग का इनाम',
  'game.king.you.is.king': 'आप किंग ऑफ गेम्स हैं',
  'game.king.will.start': 'शुरू होने वाला है',
  'game.king.brave.dragon.island': 'बहादुर ड्रैगन द्वीप',
  'game.king.cur.strogest': 'वर्तमान में सबसे शक्तिशाली',
  'game.king.attack': 'आक्रमण',
  'game.king.unused.battle': 'अप्रयुक्त युद्ध अंक',
  'game.king.current.battle': 'वर्तमान युद्ध मूल्य',
  'game.king.strongest.warrior': 'सबसे शक्तिशाली योद्धा',
  'game.king.lucky.warrior': 'भाग्यशाली योद्धा',
  'game.king.last.warrior': 'अंतिम प्रहार योद्धा',
  'game.king.warrior.ranking': 'योद्धा रैंकिंग',
  'game.king.spend.attack': 'क्या आप {N} युद्ध शक्ति खर्च कर आक्रमण करना चाहते हैं?',
  'game.king.not.reminder': 'और कोई अनुस्मारक नहीं',
  'game.king.reminder': 'अनुस्मारक',
  'game.king.go.center': 'प्रिय, आपकी युद्ध शक्ति अपर्याप्त है। कृपया गेम्स में भाग लें और युद्ध शक्ति प्राप्त करें।',
  'game.king.get.rewards': 'पुरस्कार प्राप्त करें',
  'game.king.other.king.rewards': '{nickname} को बधाई हो, {Awardname} बनने पर और {receiveCoin} गोल्ड प्राप्त करने के लिए!',
  'game.king.reward.name': 'पुरस्कार का नाम',
  'game.king.reward': 'पुरस्कार',
  'game.king.award.time': 'पुरस्कार समय',
  'game.king.warrior.rewards': 'योद्धा पुरस्कार',
  'game.king.self.king.rewards': '{Awardname} बनने पर और {receiveCoin} गोल्ड प्राप्त करने के लिए बधाई।',
  'game.king.warrior.dialog.text': '{Awardname} बनने पर {time} को बधाई हो और आपको {receiveCoin} गोल्ड के कॉइन्स मिले!',
  'game.king.king.model.coin': 'सिंहासन के लिए लड़ाई: {receiveCoin} गोल्ड के कॉइन्स प्राप्त करना।',
  'game.king.king.model.times': 'आज आप गेम्स के किंग कितनी बार बने हैं: {amount}।',
  'game.king.divide.pool': 'गोल्ड कॉइन्स का पूल बांटें*{receiveCoin}',
  'game.king.cog': 'बधाई हो!',
  'game.king.end.desc': 'प्रिय बहादुर योद्धा, \nयोद्धा रैंकिंग में आपकी #{rankings} उपलब्धि पर बधाई, और निम्नलिखित इनाम प्राप्त करें।',
  'game.king.yes': 'यस',
  'game.king.no': 'नो',
  'game.king.become.self': 'बनने पर बधाई {Awardname}',
  'game.king.become.nick': '{nickname} को बधाई हो, {Awardname} बनने पर और',
  'game.list.play.now': 'Ayo main game',
  'game.list.rewards.coin.reward.title': 'Hadiah Mata Uang',
  'game.list.rewards.coin.reward.tag': 'Ambang penghargaan',
  'game.list.rewards.prop.reward.title': 'Hadiah Alat Peraga',
  'jungle.e.not.start': 'Event akan dimulai',
  'jungle.e.tab1': 'Pemburu Harta',
  'jungle.e.tab2': 'Ranking',
  'jungle.e.tab3': 'Harta Coin Super',
  'jungle.e.tool.title': 'Kumpulkan tools untuk synthetic peti harta',
  'jungle.e.combine': 'Synthetic',
  'jungle.e.times': 'X{N} kali',
  'jungle.e.treasure': 'X{N}',
  'jungle.e.tip.desc': 'Kamu punya lebih dari {N} harta untuk di Synthetic, Synthetic sekarang?',
  'jungle.e.ok': 'OK',
  'jungle.e.collect.title': 'Pemburu hutan',
  'jungle.e.collect.desc': 'Koleksi map harian untuk dapat spesial gift dan gunakan untuk multiply {N}x Poin Ranking Charm',
  'jungle.e.day.refresh': 'Direset setiap jam',
  'jungle.e.record': 'Histori',
  'jungle.e.draw.time': 'draw*{%d}',
  'jungle.e.ticket.enough': 'Kartu hunter tidak cukup, selesaikan task untuk dapatkan lagi',
  'jungle.e.win.desc': 'Selamat telah menangkan hadiah berikut',
  'jungle.e.draw.again': 'Draw lagi',
  'jungle.e.time': 'Waktu',
  'jungle.e.rechrge': 'Top Up',
  'jungle.e.send': 'Kirim',
  'jungle.e.sec.tab1': 'Hunter Ranking',
  'jungle.e.sec.tab2': 'Charm Ranking',
  'jungle.e.daily': 'Harian',
  'jungle.e.Total': 'Total',
  'jungle.e.self.last': '{N} dari sebelumnya',
  'jungle.e.target': 'Ambang Batas: {N}',
  'jungle.e.coin.reach': 'Semua member capai {N} untuk buka Harta Coin Super',
  'jungle.e.coin.finish': 'Synthetic harta, dan dapatkan banuak coin dari Harta Coin Super',
  'jungle.e.coin.reach.anchor': 'Buka Harta Diamond Super ketika total gift event mencapai {N}',
  'jungle.e.coin.finish.anchor': 'Dapat banyak gilit limited dan dapatkan lebih banyak diamond',
  'jungle.e.wating.unlocked': 'Jumlah hadiah yang dapat dibuka',
  'jungle.e.pool.amount': 'Jumlah total hadiah',
  'jungle.e.divied.coin': 'Total coin dapat dibagi: {N} coin',
  'jungle.e.divied.coin.anchor': 'Currently you can share {N} diamonds',
  'jungle.e.send.lock': 'Kirim {N} Coin lagi untuk membuka',
  'jungle.e.send.lock.anchor': 'Terima {N} Coin lagi untuk membuka',
  'jungle.e.btn.finish': 'Kirim gift event terus, dapatkan lebih banyak coin>>',
  'jungle.e.btn.finish.anchor': 'Terima gift event terus, dapatkan lebih banyak Diamond!',
  'jungle.e.coin.rewards': 'Hadiah harta super',
  'jungle.e.winner.list': 'Daftar Pemenang',
  'jungle.e.win': 'Menang',
  'jungle.e.event.gift': 'Event Gift',
  'jungle.e.cong.title': 'Selamat!',
  'crazy.bulider.ranking': 'Ranking',
  'crazy.bulider.daily.top1': 'Daily TOP1',
  'crazy.bulider.floors.n': 'Floors{N}',
  'crazy.bulider.build.n': 'Build {N} Time',
  'crazy.bulider.build.all': 'Build All',
  'crazy.bulider.luck.gift.desc': 'Send lucky gift every {N} coins = 1{hammerIcon}',
  'crazy.bulider.rewards.tab1': 'Floor Rewards',
  'crazy.bulider.rewards.tab2': 'Ranking Rewards',
  'crazy.bulider.daily': 'Daily Ranking',
  'crazy.bulider.total': 'Total Ranking',
  'crazy.bulider.congura': 'Congratulations!',
  'crazy.bulider.model.rewards.desc': 'You have been awarded',
  'crazy.bulider.ok': 'OK',
  'crazy.bulider.opps': 'Opps!',
  'crazy.bulider.time.not.desc': 'Insufficient build times!<br/>The grand prize is waiting for you!',
  'crazy.bulider.get.more': 'GET MORE',
  'crazy.bulider.celebrate.desc': 'Congras on building {N} floors!',
  'crazy.bulider.lucky.moment': '⭐️Lucky Moment⭐️',
  'crazy.bulider.lucky.desc': 'Choose 1 Lucky Box to get bonus!',
  'crazy.bulider.click.celebrate': 'Click To Celebrate',
  'crazy.bulider.waiting': 'Waiting',
  'crazy.bulider.status.start': 'Event is about to start',
  'crazy.bulider.status.end': 'The event is over',
  'crazy.bulider.status.count': 'Countdown',
  'crazy.bulider.share.moment': 'Share To Moment',
  'crazy.bulider.share': 'Share',
  'crazy.bulider.share.ok': 'OK',
  'crazy.bulider.share.desc1': 'You already surpassed 90% of the constructors! Quickly share the current view with your friends!',
  'crazy.bulider.share.desc2': '*First time successful sharing to Moment can get exclusive rewards for super constructors ↓.,',
  'crazy.bulider.share.desc3': '{X} people also start constructing buildings by seeing your moment!',
  'crazy.bulider.share.desc4': 'Thank you for your influence!',
  'crazy.bulider.share.desc5': 'The skyscrapers are under my control!',
  'crazy.bulider.share.reward': 'You have been rewarded',
  'crazy.bulider.progress.current': 'Current:{M}={N}',
  'crazy.bulider.progress.target': 'Target:',
  'crazy.bulider.share.text': '#👷Crazy Constructor🚧#\nSuper Power Affects the World! 🌏\n{N} Floors built with passion🔥\nGlobal Ranking: #{Rank} 👑\nNice chance to build own skyscraper!🏙',
  'crazy.bulider.share.success': 'Shared Success!',
  'family.battle.new.up.need.s': 'Naik Butuh {N}',
  'hungry.ghost.collect': 'Ambil',
  'hungry.ghost.ok': 'OK',
  'hungry.ghost.waiting': 'Menunggu',
  'hungry.ghost.special.gift.title': 'welfare treasure box',
  'hungry.ghost.special.gift.to.be.drawn': 'Untuk Draw',
  'hungry.ghost.special.gift.to.complete': 'Selesaikan Sekarang',
  'hungry.ghost.special.gift.contribution': 'Chest Kontribusi',
  'hungry.ghost.special.gift.lucky': 'Lebaran Hoki Chest',
  'hungry.ghost.special.gift.desc': 'Accumulated limited gift value received {%d} coins can participate in the selection of lucky stars ({%z}/{%m})',
  'hungry.ghost.tab.scene': 'Trip idul fitri',
  'hungry.ghost.tab.ranking': 'Ranking',
  'hungry.ghost.scene.tips': 'Kirim gift limited dan capai target coin untuk membuka scene dan dapatkan hadiah. MVP akan dapat tambahan hadiah.',
  'hungry.ghost.scene.rewards.desc': 'Setelah berpatisipasi untuk membuka scene saat ini, kamu akan mendapatkan hadiah berikut, dan untuk MVP akan mendapatkan hadiah tambahan',
  'hungry.ghost.scene.unlock.modal.title': 'Selamat dalam partisipasi membuka lokasi:',
  'hungry.ghost.scene.unlock.modal.you.can.get': 'Bisa dapat',
  'hungry.ghost.scene.unlock.modal.mvp.tag': 'MVP bisa dapat',
  'hungry.ghost.rewards.tips': 'For details on getting Coins and Diamonds, please check the rules page.',
  'hungry.ghost.go.look': 'Cek Sekarang!',
  'hungry.ghost.no.time.yet': 'Belum waktunya',
  'hungry.ghost.next.round': 'Next round',
  'hungry.ghost.ranking.tab.send': 'Wealth Ranking',
  'hungry.ghost.ranking.tab.receive': 'Charm Ranking',
  'fishing.activity.bomber': 'Bomber',
  'fishing.activity.fishnet': 'Fishnet',
  'fishing.activity.energy.not': 'Energy value is insufficient!',
  'fishing.activity.get.more': 'GET MORE',
  'fishing.activity.congrats': 'Congrats!',
  'fishing.activity.ok': 'OK',
  'fishing.activity.catches.more': 'There are new catches!',
  'fishing.activity.put.aquarium': 'Put into Aquarium',
  'fishing.activity.catche.single': 'There\'s a new catch!',
  'fishing.activity.new': 'NEW',
  'fishing.activity.slipped.away': 'The fish slipped away!',
  'fishing.activity.try.again': 'TRY AGAIN',
  'fishing.activity.step1': 'Welcome! Click on the fishing rod to fish for free!',
  'fishing.activity.step3': 'Getting a new type of fish can be lighted in aquarium, and collecting all fish can get rich coins rewards!',
  'fishing.activity.step5': 'Fish again!',
  'fishing.activity.fishing.big': 'Lucky! Meet Big Fish! Click the rod to increase the pulling force and reach the target value to catch the big fish!',
  'fishing.activity.step8': 'Congrats to get a free Bomber! Try the power of Bomber now!',
  'fishing.activity.step10': 'Catch duplicate types of fish will be exchanged automatically for Coupons, which can be used to buy items in the Store!',
  'fishing.activity.step12': 'Come back tomorrow can get 1 more free Bomber!',
  'fishing.activity.start.fishing': 'Start to fishing',
  'fishing.activity.cap.Records': 'Records',
  'fishing.activity.cap.Unfinished': 'Unfinished',
  'fishing.activity.cap.Date': 'Date',
  'fishing.activity.cap.no.record.yet': 'No record yet.',
  'fishing.activity.store': 'STORE',
  'fishing.activity.gallery': 'AQUARIUM',
  'fishing.activity.rank': 'SUPERSTAR',
  'fishing.activity.energy': 'ENERGY',
  'fishing.activity.achievement': 'ACHIEVEMENT',
  'fishing.activity.records.fish': 'Fish',
  'fishing.activity.records.coupon': 'Coupon',
  'fishing.activity.records.others': 'Others',
  'fishing.activity.store.limit': 'Limit:',
  'fishing.activity.store.buy': 'Buy',
  'fishing.activity.store.sold.out': 'SOLD OUT',
  'fishing.activity.gallery.tips': 'Collect all kinds of fish to receive generous coins!',
  'fishing.activity.rank.tips': 'Daily TOP 5 Fishing Stars get extra rewards!',
  'fishing.activity.energy.tips': 'Daily tasks update at 00:00,remember to collect rewards on time!',
  'fishing.activity.fish.ticket.not': 'Coupon is insufficient!',
  'fishing.activity.you.got': 'You have been awarded:',
  'fishing.activity.go': 'Go',
  'fishing.activity.not.time': 'This stage is about to start',
  'anniversary.celebration.2.collect': 'Ambil',
  'anniversary.celebration.2.ok': 'OK',
  'anniversary.celebration.2.waiting': 'Menunggu',
  'anniversary.celebration.2.special.gift.title': 'welfare treasure box',
  'anniversary.celebration.2.special.gift.to.be.drawn': 'Untuk Draw',
  'anniversary.celebration.2.special.gift.to.complete': 'Selesaikan Sekarang',
  'anniversary.celebration.2.special.gift.contribution': 'Charming Chest',
  'anniversary.celebration.2.special.gift.lucky': 'Lebaran Hoki Chest',
  'anniversary.celebration.2.special.gift.desc': 'Accumulated limited gift value received {%d} coins can participate in the selection of lucky stars ({%z}/{%m})',
  'anniversary.celebration.2.tab.scene': 'Celebration Journey',
  'anniversary.celebration.2.tab.ranking': 'Ranking',
  'anniversary.celebration.2.scene.tips': 'All platforms coins consumption(except game part&send lucky package) reaches target value to unlock scenes to get rewards. Send limited gifts can get doulbe points!',
  'anniversary.celebration.2.scene.rewards.desc': 'Setelah berpatisipasi untuk membuka scene saat ini, kamu akan mendapatkan hadiah berikut, dan untuk MVP akan mendapatkan hadiah tambahan',
  'anniversary.celebration.2.scene.unlock.modal.title': 'Selamat dalam partisipasi membuka lokasi:',
  'anniversary.celebration.2.scene.unlock.modal.you.can.get': 'Bisa dapat',
  'anniversary.celebration.2.scene.unlock.modal.mvp.tag': 'MVP bisa dapat',
  'anniversary.celebration.2.rewards.tips': 'For details on getting Coins and Diamonds, please check the rules page.',
  'anniversary.celebration.2.go.look': 'Cek Sekarang!',
  'anniversary.celebration.2.no.time.yet': 'Belum waktunya',
  'anniversary.celebration.2.next.round': 'Next round',
  'anniversary.celebration.2.ranking.tab.send': 'Wealth Ranking',
  'anniversary.celebration.2.ranking.tab.receive': 'Charm Ranking',
  'crazybuilder.king.record': 'All-time high Record',
  'crazybuilder.mine.record': 'My Current Record',
  'gamecenter_ranking_txt6': 'daftar keberuntungan',
  'gamecenter_ranking_txt7': 'Menangkan lebih dari 5s000 koin dalam game untuk memenuhi syarat ke papan peringkat, dengan pengguna terbaru yang memenuhi syarat mendapat peringkat lebih tinggi.',
  'iosso_wallet_txt1': 'Lagi',
  'iosso_wallet_txt2': 'तह Melipat',
  'new.ranking.list.charm': 'Charm',
  'new.ranking.list.contribution': 'Kontribusi',
  'new.ranking.list.record': 'Histori',
  'game.list.plus.empyt.list': 'Tidak ada data',
  'withdraw_text_0': 'penghasilan',
  'withdraw_text_1': 'keseimbangan',
  'withdraw_text_2': 'menarik',
  'withdraw_text_3': 'menukarkan',
  'withdraw_text_4': 'Catatan penarikan',
  'withdraw_text_5': 'Saldo berlian tidak mencukupi',
  'withdraw_text_6': 'Dapatkan lebih banyak berlian',
  'withdraw_text_7': 'jumlah order:',
  'withdraw_text_8': 'saluran:',
  'withdraw_text_9': 'Jumlah:',
  'withdraw_text_10': 'berlian:',
  'withdraw_text_11': 'jadwal:',
  'withdraw_text_12': 'sedang ditinjau',
  'withdraw_text_13': 'Penarikan berhasil',
  'withdraw_text_14': 'Penarikan gagal',
  'withdraw_text_15': 'Alasan kegagalan',
  'share_text100': 'Replikasi',
  'withdraw_text_16': 'Hanya tampilkan catatan dari 3 bulan terakhir',
  'withdraw_text_21': 'Jumlah penarikan',
  'withdraw_text_22': 'dikurangi berlian',
  'withdraw_text_23': 'Cara Pembayaran:',
  'withdraw_text_24': 'Tambahkan metode pembayaran',
  'withdraw_text_25': 'Tarik segera',
  'withdraw_text_27': 'Pertanyaan umpan balik',
  'withdraw_text_28': 'Hubungi Layanan Pelanggan',
  'withdraw_text_30': '1. Penarikan diperbolehkan maksimal satu kali sehari',
  'withdraw_text_31': '2. Anda harus menyelesaikan otentikasi orang asli dan mengikat metode pembayaran sebelum Anda dapat melakukan penarikan.',
  'withdraw_text_32': '3. Platform tidak memungut biaya apa pun. Biaya layanan dipotong oleh saluran. Biaya layanan berbeda untuk saluran yang berbeda.',
  'withdraw_text_33': '4. Kemajuan penarikan dapat dilihat melalui \'Catatan Penarikan\'',
  'withdraw_text_34': '5. Jika penarikan gagal, berlian akan dikembalikan',
  'withdraw_text_35': '6. Permohonan penarikan akan diproses dalam waktu 7-14 hari kerja (perpanjangan pada hari libur)',
  'withdraw_text_36': 'harus diselesaikan',
  'withdraw_text_37': '1. Otentikasi orang sungguhan',
  'withdraw_text_38': '2. Tambahkan metode pembayaran',
  'program_faq_13_ios': 'Tips',
  'exchange_text_1': 'Pertukaran',
  'exchange_text_2': 'Saldo Koin',
  'exchange_text_3': 'Saldo Berlian',
  'exchange_text_4': 'Tukar Kustom',
  'exchange_text_5': 'Aturan Tukar',
  'exchange_text_6': 'Nilai Tukar',
  'exchange_text_7': 'Batas Tukar Harian',
  'exchange_text_8': 'Konfirmasi Tukar?',
  'exchange_text_9': 'Dibelanjakan:',
  'exchange_text_10': 'Dapatkan:',
  'exchange_text_13': 'Diamond balance tidak cukup',
  'withdraw_text_42': 'Tidak ada metode pembayaran yang didukung',
  'withdraw_text_39': 'mengikat',
  'withdraw_text_40': 'Memeriksa',
  'exchange_text_18': 'Melampaui batas pertukaran.',
  'exchange_text_14': 'Penukaran berhasil',
  'ios_rechargeguide_txt3': 'Koin Kembali',
  'ios_rechargeguide_txt4': 'Mengeklaim',
  'program_faq_2': 'Pengenalan Jadwal program',
  'program_faq_3': 'Untuk meningkatkan kesenangan dan interaktivitas, kami menyediakan fitur jadwal program. Jadwal program berfungsi sebagai pratinjau program ruangan yang akan datang. Pemirsa dapat memilih dan mengirim hadiah berdasarkan jadwal program, mengekspresikan preferensi dan antusiasme mereka terhadap program ruangan.',
  'program_faq_4': 'Halaman Jadwal program',
  'program_faq_5': 'Pemilik atau administrator room dapat mengakses jadwal program melalui menu Settings. Pemirsa dapat memasukkan jadwal program dengan mengklik sudut kanan atas ruangan saat program ditayangkan.',
  'program_faq_6': 'Cara Membuat jadwal program',
  'program_faq_7': 'Click Tambahkan program dan masukan nama program yang di inginkan.',
  'program_faq_8': 'Setelah membuat dan meninjau jadwal program, klik \"Mulai Jadwal Program\" untuk membuatnya terlihat oleh audiens. Setelah diaktifkan, pemirsa akan dapat melihat jadwal program.',
  'program_faq_9': 'Cara melakukan interaksa bersama jadwal program',
  'program_faq_10': 'Semua orang di ruangan dapat mengakses jadwal program dengan mengklik sudut kanan atas dan menunjukkan dukungan untuk program favorit mereka dengan mengklik \"Tertarik\" atau \"Kirim Hadiah\" untuk meningkatkan popularitas program.',
  'program_faq_11': 'Hapus program',
  'program_faq_12': 'Pemilik atau administrator ruang dapat menggesek ke kiri pada program dan mengklik \"Hapus\" untuk menghapus program. Jadwal program akan ditutup secara otomatis setelah 7 hari, tetapi host atau administrator juga dapat menutupnya secara manual. Menghapus program atau menutup jadwal program akan menghapus data popularitas program.',
  'program_faq_13': 'Tips',
  'program_faq_14': '1.Jadwal yang bisa dibuat maximal 15 Program',
  'program_faq_15': '2.Jadwal program gagal di review dan tidak bisa di buka',
  'program_faq_16': '3.Jadwal Program automatis selesai setelah 7 dilaksanakan',
  'program_faq_part1': 'Part 1',
  'program_faq_part2': 'Part 2',
  'program_faq_part3': 'Part 3',
  'program_faq_part4': 'Part 4',
  'withdraw_text_45': 'Waktu penyerahan',
  'withdraw_text_46': 'Ini akan tiba di akun Anda dalam 5 hari kerja. Kemajuan spesifik dapat diperiksa di catatan penarikan.',
  'withdraw_text_47': 'Menyelesaikan',
  'withdraw_text_48': 'Cara Pembayaran',
  'payment_bind_1': 'akun',
  'exchange_text_16': 'Pertukaran gagal.',
  'withdraw_text_59': 'Memperbarui',
  'payment_bind_28': 'Jenis Akun',
  'payment_bind_29': 'PAYPAL_ID',
  'family_text_116': 'Disarankan',
  'family_text_117': 'Peringkat',
  'family_text_97': 'Hari ini',
  'family_text_98': 'bulanan',
  'family_text_108': 'Kemarin',
  'family_text_69': 'Bulan kemarin',
  'family_text_95': 'Popular',
  'family_text_96': 'New',
  'family_text_68': 'Bulan ini',
  'family_toast_03': 'Bergabung',
  'family_toast_04': 'Sedang di Check',
  'family_toast_05': 'Sukses bergabung di Keluarga',
  'family_toast_02': 'aplikasi telah di masukan. Mohon menunggu proses persetujuan.',
  'family_toast_08': 'Membuat keluarga',
  'family_enter': 'Keluarga',
  'specialoffer_9': 'Penawaran Spesial',
  'specialoffer_10': '{%s} Koin',
  'rewardboost_24': 'Tidak ada Penawaran Khusus yang tersedia.',
};

export default ID;
